/* Saturo Ratgeber (Blog-Redesign v2). Vanilla JS, kein Framework.
   Aufgaben: Reveal beim Scrollen, Kapitel-Navigation (mobile Leiste + Desktop-Rail),
   Fortschrittsbalken-Fallback, Produkt-Rail + Sticky-Kaufleiste, Rechner, Checkliste,
   Balken-Diagramm, Audio-Player, Link kopieren. Alles idempotent (Theme-Editor lädt Sections neu). */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  root.classList.add('rg-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* Scroll-Events im Capture-Modus am document abgreifen: das Theme scrollt nicht immer am window */
  function onScroll(fn) { doc.addEventListener('scroll', fn, { passive: true, capture: true }); window.addEventListener('scroll', fn, { passive: true }); }
  function q(sel, ctx) { return (ctx || doc).querySelector(sel); }
  /* Volle-Breite-Sektionen (dunkles Band): Rails ausblenden, solange sie das Band überlappen */
  function overlapsBand(el) {
    var bands = qa('.rg-band'); if (!bands.length || !el) return false;
    var r = el.getBoundingClientRect(); if (!r.height) return false;
    return bands.some(function (band) { var b = band.getBoundingClientRect(); return b.top < r.bottom + 24 && b.bottom > r.top - 24; });
  }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  function init() {
    if (!q('.rg')) return;
    headerOffset();
    drawerWatch();
    reveals();
    progress();
    chapters();
    rails();
    calculators();
    matrix();
    refuel();
    checklists();
    lookup();
    bottles();
    swap();
    goal();
    kcal();
    decider();
    finder();
    scale();
    clock();
    fastwin();
    stock();
    prep();
    plan();
    builder();
    energy();
    weight();
    waist();
    bars();
    stackbars();
    protein();
    flavors();
    audio();
    share();
    newsletter();
    ixLoadMore();
  }

  /* Höhe des (sticky) Headers als CSS-Variable, damit Leiste und Rails darunter sitzen */
  function headerOffset() {
    var header = q('header-component') || q('.header-section') || q('#header-group') || q('header');
    var last = null;
    function measure() {
      var b = 0;
      if (header) {
        var r = header.getBoundingClientRect();
        /* Unterkante des Headers im Viewport; ganz oben liegt sie wegen der Ankuendigungsleiste tiefer als die Header-Hoehe */
        if (r.height > 0) b = Math.max(0, r.bottom);
        /* Horizon "scroll-up"-Header: im Zustand idle ist er unsichtbar (opacity 0), auch wenn er noch im Viewport liegt */
        if (header.getAttribute && header.getAttribute('data-sticky-state') === 'idle') b = 0;
      }
      if (!b && !(header && header.getAttribute && header.getAttribute('data-sticky-state') === 'idle')) {
        var v = parseFloat(getComputedStyle(doc.body).getPropertyValue('--header-height'));
        if (v > 0 && window.scrollY > 0) b = v;
      }
      b = Math.round(b);
      if (b !== last) { last = b; root.style.setProperty('--rg-header-bottom', b + 'px'); }
    }
    /* Der Horizon-Header schaltet seinen Sticky-Zustand erst im naechsten Animation-Frame nach dem Scroll-Event um.
       Deshalb einmal sofort messen und noch einmal zwei Frames spaeter, sonst bleibt die Kapitel-Leiste beim
       Anhalten des Scrollens auf der alten Position (ueber statt unter dem Header). */
    function upd() {
      measure();
      requestAnimationFrame(function () { requestAnimationFrame(measure); });
    }
    upd();
    onScroll(upd);
    window.addEventListener('resize', upd);
    if (header && window.MutationObserver) {
      new MutationObserver(function () { requestAnimationFrame(measure); })
        .observe(header, { attributes: true, attributeFilter: ['data-sticky-state', 'data-scroll-direction', 'sticky'] });
    }
  }

  /* Offener Theme-Drawer (Warenkorb, Menue, Suche): Desktop schiebt die Seite nach links (.page-wrapper--drawer-open),
     Mobil sperrt das Scrollen (html[scroll-lock]). In beiden Faellen gehoeren die fixierten Ratgeber-Elemente weg,
     sonst liegen Rails ueber Text und Warenkorb. Body-Klasse statt :has() (Style-Recalc). */
  function drawerWatch() {
    var pw = q('.page-wrapper');
    function upd() {
      var open = root.hasAttribute('scroll-lock') || !!(pw && pw.classList.contains('page-wrapper--drawer-open')) || !!q('dialog[open]');
      doc.body.classList.toggle('rg-drawer-open', open);
    }
    upd();
    if (!window.MutationObserver) return;
    new MutationObserver(upd).observe(root, { attributes: true, attributeFilter: ['scroll-lock'] });
    if (pw) new MutationObserver(upd).observe(pw, { attributes: true, attributeFilter: ['class'] });
    doc.addEventListener('toggle', upd, true);
  }

  function reveals() {
    var els = qa('.rg-rv:not(.rg-in)');
    if (!els.length) return;
    if (!hasIO || reduce) { els.forEach(function (el) { el.classList.add('rg-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('rg-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () { els.forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight * 1.2) el.classList.add('rg-in'); }); }, 50);
  }

  function progress() {
    var pb = q('.rg-progress');
    if (!pb || pb.dataset.rgInit) return;
    pb.dataset.rgInit = '1';
    if (pb.parentNode !== doc.body) doc.body.appendChild(pb);
    if (window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()')) return;
    function upd() { var h = root; var p = h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight); pb.style.transform = 'scaleX(' + Math.max(0, Math.min(1, p)) + ')'; }
    onScroll(upd); upd();
  }

  /* Kapitel: aus allen [data-rg-chapter] die Leiste (mobil) und die Rail (Desktop) bauen */
  function chapters() {
    var secs = qa('[data-rg-chapter]');
    var strip = q('[data-rg-chapters]'), rail = q('[data-rg-rail]');
    if (!secs.length || (!strip && !rail)) return;
    var html = secs.map(function (s) {
      return '<li><a href="#' + s.id + '"><b>' + (s.getAttribute('data-rg-num') || '') + '</b>' + (s.getAttribute('data-rg-nav') || s.getAttribute('data-rg-title') || '') + '</a></li>';
    }).join('');
    if (strip) {
      if (strip.parentNode !== doc.body) doc.body.appendChild(strip);
      strip.hidden = false;
      var ol = q('ol', strip); if (ol) ol.innerHTML = html;
    }
    if (rail) {
      if (rail.parentNode !== doc.body) doc.body.appendChild(rail);
      var rol = q('ol', rail); if (rol) rol.innerHTML = html;
    }
    var links = qa('[data-rg-chapters] a, [data-rg-rail] a');
    function setActive(id) {
      links.forEach(function (a) { a.classList.toggle('rg-on', a.getAttribute('href') === '#' + id); });
      var on = q('[data-rg-chapters] a.rg-on');
      if (on && on.scrollIntoView && strip && strip.classList.contains('rg-show')) {
        try { on.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { /* alte Browser */ }
      }
    }
    var cover = q('.rg-cover'), first = secs[0], last = secs[secs.length - 1];
    var nextSec = q('.rg-next-sec');
    function updVisibility() {
      var start = first.getBoundingClientRect().top;
      var endEl = nextSec || last;
      var end = endEl.getBoundingClientRect()[nextSec ? 'top' : 'bottom'];
      var hb = parseFloat(getComputedStyle(root).getPropertyValue('--rg-header-bottom')) || 0;
      /* Rail nur, solange der Ratgeber-Bereich unter der Rail-Unterkante weitergeht; sonst ragt sie am Seitenende in den Footer (Collection ohne Weiter-/Trust-Block, 16.09.2026) */
      var railH = rail ? rail.offsetHeight : 0;
      var inArticle = start < hb + 120 && end > hb + 32 + Math.max(railH, 128);
      if (strip) strip.classList.toggle('rg-show', inArticle);
      if (rail) { rail.classList.toggle('rg-show', inArticle); rail.classList.toggle('rg-band-hide', overlapsBand(rail)); }
    }
    onScroll(updVisibility);
    window.addEventListener('resize', updVisibility);
    updVisibility();
    if (hasIO) {
      var cio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) setActive(e.target.id); });
      }, { rootMargin: '-35% 0px -55% 0px' });
      secs.forEach(function (s) { cio.observe(s); });
    }
    setActive(first.id);
    void cover;
  }

  /* Produkt-Rail rechts + Sticky-Kaufleiste unten */
  function rails() {
    var railr = q('[data-rg-railr]'), bar = q('[data-rg-stickybar]'), inline = q('[data-rg-product-inline]');
    var chs = qa('[data-rg-chapter]'), first = chs[0], nextSec = q('.rg-next-sec') || q('.rg-trust'), lastCh = chs[chs.length - 1];
    /* ohne Weiter-/Trust-Block (z. B. Collection) endet der Bereich mit dem letzten Kapitel; `:last-of-type` traf sonst das erste Kapitel */
    if (railr && railr.parentNode !== doc.body) doc.body.appendChild(railr);
    if (bar && bar.parentNode !== doc.body) doc.body.appendChild(bar);
    if (!railr && !bar) return;
    var seen = false, inlineVisible = false;
    function upd() {
      var hb = parseFloat(getComputedStyle(root).getPropertyValue('--rg-header-bottom')) || 0;
      var start = first ? first.getBoundingClientRect().top : 0;
      var end = nextSec ? nextSec.getBoundingClientRect().top : (lastCh ? lastCh.getBoundingClientRect().bottom : 1e9);
      var railrH = railr ? railr.offsetHeight : 0;
      var inArticle = start < hb + 120 && end > hb + 32 + Math.max(railrH, 288);
      if (railr) { railr.classList.toggle('rg-show', inArticle); railr.classList.toggle('rg-dim', inlineVisible); railr.classList.toggle('rg-band-hide', overlapsBand(railr)); }
      if (bar) { var barOn = inArticle && seen && !inlineVisible; bar.classList.toggle('rg-show', barOn); doc.body.classList.toggle('rg-sticky-on', barOn); }
    }
    if (hasIO && inline) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { inlineVisible = e.isIntersecting; if (e.isIntersecting) seen = true; upd(); }); }, { threshold: .1 }).observe(inline);
    } else { seen = true; }
    onScroll(upd);
    window.addEventListener('resize', upd);
    upd();
  }

  /* Bedarfsrechner: Buttons mit data-value/data-text, Ring skaliert auf data-max */
  function calculators() {
    qa('[data-rg-calc]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var btns = qa('.rg-seg button', w), val = q('[data-rg-calc-value]', w), txt = q('[data-rg-calc-text]', w), fg = q('.rg-fg', w);
      var max = parseFloat(w.getAttribute('data-max')) || 30;
      /* deutsche Schreibweise: Tausenderpunkt, Dezimalkomma; data-len steuert die Schriftgroesse im Ring */
      function fmt(s) {
        s = String(s || '').trim();
        var m = s.match(/^(\d+)(?:[.,](\d+))?$/);
        if (!m) return s;
        var i = m[1].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return m[2] ? i + ',' + m[2] : i;
      }
      function show(s) { val.textContent = fmt(s); val.setAttribute('data-len', String(val.textContent.length)); }
      if (val) show(val.textContent);
      function set(b) {
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var v = parseFloat(String(b.getAttribute('data-value')).replace(',', '.')) || 0;
        if (val) show(b.getAttribute('data-value'));
        if (txt) txt.innerHTML = '<b>' + b.textContent.trim() + ':</b> ' + (b.getAttribute('data-text') || '');
        if (fg) fg.style.strokeDashoffset = String(314 - 314 * Math.min(1, v / max));
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { set(b); }); });
      if (!btns.length) return;
      /* Startoption = der Button, den das Liquid mit aria-pressed markiert hat (Vorauswahl Erwachsene) */
      var start = btns[0];
      for (var si = 0; si < btns.length; si++) { if (btns[si].getAttribute('aria-pressed') === 'true') { start = btns[si]; break; } }
      if (hasIO && !reduce) {
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { set(start); io.disconnect(); } }); }, { threshold: .3 });
        io.observe(w);
      } else { set(start); }
    });
  }

  /* Matrix-Rechner (Zinkmangel 22.09.2026): Reihe A x Reihe B -> Zelle (Wert, Text), Ring skaliert auf data-max */
  function matrix() {
    qa('[data-rg-matrix]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var ra = qa('[data-rg-matrix-a] button', w), rb = qa('[data-rg-matrix-b] button', w), cells = qa('[data-rg-matrix-cells] span', w);
      var val = q('[data-rg-matrix-value]', w), txt = q('[data-rg-matrix-text]', w), fg = q('.rg-fg', w);
      var max = parseFloat(w.getAttribute('data-max')) || 16;
      function sel(list) { return list.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || list[0]; }
      function fmt(s) {
        s = String(s || '').trim();
        var m = s.match(/^(\d+)(?:[.,](\d+))?$/);
        if (!m) return s;
        var i = m[1].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); /* Tausenderpunkt (Kalorienrechner 14.10.2026: 1.900 kcal) */
        return m[2] ? i + ',' + m[2] : i;
      }
      function calc() {
        var a = sel(ra), b = sel(rb); if (!a || !b) return;
        var ka = a.getAttribute('data-key'), kb = b.getAttribute('data-key');
        var cell = cells.filter(function (c) { return c.getAttribute('data-a') === ka && c.getAttribute('data-b') === kb; })[0];
        if (!cell) return;
        var raw = cell.getAttribute('data-value') || '', v = parseFloat(raw.replace(',', '.')) || 0;
        if (val) { val.textContent = fmt(raw); val.setAttribute('data-len', String(val.textContent.length)); }
        if (txt) {
          var bt = b.getAttribute('data-text') || '';
          txt.innerHTML = '<b>' + a.textContent.trim() + ', ' + b.textContent.trim() + ':</b> ' + (cell.getAttribute('data-text') || '') + (bt ? ' <span class="rg-matrix__hint">' + bt + '</span>' : '');
        }
        if (fg) fg.style.strokeDashoffset = String(314 - 314 * Math.min(1, v / max));
      }
      [ra, rb].forEach(function (list) {
        list.forEach(function (b) {
          b.addEventListener('click', function () { list.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); calc(); });
        });
      });
      if (!ra.length || !rb.length) return;
      if (hasIO && !reduce) {
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { calc(); io.disconnect(); } }); }, { threshold: .3 });
        io.observe(w);
      } else { calc(); }
    });
  }

  /* Post-Workout-Teller (Essen nach dem Sport 14.10.2026): Gewicht x Training x Ziel -> Protein g, Kohlenhydrate g,
     Zeitpunkt aus der Trainingsreihe, naechster Beispielteller aus der Liste (Abstand in Protein/15 + KH/20 Schritten) */
  function refuel() {
    qa('[data-rg-refuel]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var rows = { w: qa('[data-rg-refuel-weights] button', w), t: qa('[data-rg-refuel-trains] button', w), g: qa('[data-rg-refuel-goals] button', w) };
      var plates = qa('[data-rg-refuel-plates] span', w), kgIn = q('[data-rg-refuel-kg]', w);
      var outP = q('[data-rg-refuel-p]', w), outC = q('[data-rg-refuel-c]', w), unitC = q('[data-rg-refuel-cunit]', w);
      var when = q('[data-rg-refuel-when]', w), plate = q('[data-rg-refuel-plate]', w), txt = q('[data-rg-refuel-text]', w);
      function num(s) { return parseFloat(String(s || '').replace(',', '.')) || 0; }
      function sel(list) { return list.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || list[0]; }
      function r5(v) { return Math.round(v / 5) * 5; }
      var pmin = num(w.getAttribute('data-pmin')) || 15, pmax = num(w.getAttribute('data-pmax')) || 40;
      function calc() {
        var ws = sel(rows.w), t = sel(rows.t), g = sel(rows.g); if (!t || !g) return;
        /* genaues Gewicht aus dem Eingabefeld (30 bis 250 kg) schlaegt die Chips */
        var typed = kgIn ? num(kgIn.value) : 0, exact = typed >= 30 && typed <= 250;
        var kg = exact ? typed : (ws ? num(ws.getAttribute('data-kg')) : 70);
        var pf = num(g.getAttribute('data-protein')), cf = num(t.getAttribute('data-carb'));
        var urgent = t.getAttribute('data-urgent') === '1', cm = urgent ? 1 : (num(g.getAttribute('data-carb-mult')) || 1);
        var p = Math.min(pmax, Math.max(pmin, r5(kg * pf))), c = r5(kg * cf * cm);
        if (outP) outP.textContent = String(p);
        if (outC) outC.textContent = String(c);
        if (unitC) unitC.textContent = t.getAttribute('data-unit') || unitC.textContent;
        if (when) when.textContent = t.getAttribute('data-when') || '';
        var best = null, bd = 1e9;
        plates.forEach(function (pl) {
          /* zu wenig Protein wiegt doppelt, zu viel nur halb (mehr Protein schadet dem Ziel nicht) */
          var dp = num(pl.getAttribute('data-p')) - p, dc = Math.abs(num(pl.getAttribute('data-c')) - c);
          var d = (dp < 0 ? -dp * 2 : dp * 0.5) / 15 + dc / 20;
          if (d < bd) { bd = d; best = pl; }
        });
        if (plate && best) plate.innerHTML = '<b>' + best.getAttribute('data-label') + '</b> (' + best.getAttribute('data-p') + ' g Protein, ' + best.getAttribute('data-c') + ' g Kohlenhydrate): ' + (best.getAttribute('data-text') || '');
        if (txt) txt.innerHTML = '<b>' + g.textContent.trim() + ':</b> ' + (g.getAttribute('data-text') || '');
      }
      ['w', 't', 'g'].forEach(function (k) {
        rows[k].forEach(function (b) {
          b.addEventListener('click', function () {
            rows[k].forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
            if (k === 'w' && kgIn) kgIn.value = '';
            calc();
          });
        });
      });
      if (kgIn) kgIn.addEventListener('input', function () {
        var v = num(kgIn.value), ok = v >= 30 && v <= 250, last = sel(rows.w);
        /* gueltige Eingabe loest die Chips, leeres oder ungueltiges Feld faellt auf den zuletzt gewaehlten Chip zurueck */
        rows.w.forEach(function (x) { x.setAttribute('aria-pressed', !ok && x === last ? 'true' : 'false'); });
        calc();
      });
      calc();
    });
  }

  /* Checkliste: zählt angetippte Anzeichen, drei Texte je nach Anzahl */
  function checklists() {
    qa('[data-rg-check]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var btns = qa('.rg-sym button', w), res = q('[data-rg-check-result]', w);
      var t0 = w.getAttribute('data-text-0') || '', t1 = w.getAttribute('data-text-few') || '', t2 = w.getAttribute('data-text-many') || '';
      var thr = parseInt(w.getAttribute('data-threshold') || '3', 10);
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
          var n = btns.filter(function (x) { return x.getAttribute('aria-pressed') === 'true'; }).length;
          if (!res) return;
          if (n === 0) res.innerHTML = t0;
          else if (n < thr) res.innerHTML = '<span class="rg-n">' + n + '</span>' + t1;
          else res.innerHTML = '<span class="rg-n">' + n + '</span>' + t2;
        });
      });
    });
  }

  /* Nachschlagen: Suchfeld + Ampel-Filter über einer statischen Liste, ohne Suche auf data-limit eingeklappt */
  function lookup() {
    qa('[data-rg-lookup]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var inp = q('[data-rg-lookup-input]', w), items = qa('[data-rg-lookup-list] > li', w), chips = qa('.rg-lookup__filters button', w), cats = qa('.rg-lookup__cats button', w);
      var empty = q('[data-rg-lookup-empty]', w), more = q('[data-rg-lookup-more]', w), cnt = q('[data-rg-lookup-count]', w);
      var limit = parseInt(w.getAttribute('data-limit') || '10', 10), expanded = false, filter = 'all', cat = 'all';
      function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ß/g, 'ss'); }
      /* Treffer am Wortanfang oder als Wortende eines zusammengesetzten Worts (Wassereis, Milcheis), Teilstring erst ab 5 Zeichen; "eis" trifft so nicht Reis oder Hackfleisch */
      function match(name, qv) {
        return norm(name).split(/[^a-z0-9]+/).some(function (t) {
          return t.indexOf(qv) === 0 || (t.length - qv.length >= 3 && t.lastIndexOf(qv) === t.length - qv.length) || (qv.length >= 5 && t.indexOf(qv) > -1);
        });
      }
      function apply() {
        var qv = norm(inp ? inp.value.trim() : ''), total = 0, shown = 0, open = expanded || !!qv || filter !== 'all' || cat !== 'all';
        items.forEach(function (li) {
          var hit = (!qv || match(li.getAttribute('data-name'), qv)) && (filter === 'all' || li.getAttribute('data-status') === filter) && (cat === 'all' || li.getAttribute('data-cat') === cat);
          if (hit) total++;
          var vis = hit && (open || shown < limit);
          if (vis) shown++;
          li.hidden = !vis;
        });
        if (empty) empty.hidden = total > 0;
        if (more) { more.hidden = !(total > shown); more.textContent = 'Alle ' + total + ' anzeigen'; }
        if (cnt) cnt.textContent = total > shown ? shown + ' von ' + total : (qv || filter !== 'all' || cat !== 'all' ? total + ' Treffer' : '');
      }
      if (inp) inp.addEventListener('input', apply);
      cats.forEach(function (c) {
        c.addEventListener('click', function () {
          cat = c.getAttribute('data-cat') || 'all';
          cats.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
          apply();
        });
      });
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          filter = c.getAttribute('data-filter') || 'all';
          chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
          apply();
        });
      });
      if (more) more.addEventListener('click', function () { expanded = true; apply(); });
      apply();
    });
  }

  /* Flaschen-Rechner: Profil (kcal/Tag) x Ziel (Extra-kcal oder Prozent, Protein-Ziel) x Produkt (ml, kcal, Protein, Zucker) */
  function bottles() {
    qa('[data-rg-bottles]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var rows = { p: qa('[data-rg-bottles-profiles] button', w), g: qa('[data-rg-bottles-goals] button', w), r: qa('[data-rg-bottles-products] button', w) };
      var n = q('[data-rg-bottles-n]', w), unit = q('[data-rg-bottles-unit]', w), txt = q('[data-rg-bottles-text]', w);
      var out = { energy: q('[data-rg-bottles-energy]', w), volume: q('[data-rg-bottles-volume]', w), protein: q('[data-rg-bottles-protein]', w), sugar: q('[data-rg-bottles-sugar]', w), share: q('[data-rg-bottles-share]', w) };
      function num(s) { return parseFloat(String(s || '').replace(',', '.')) || 0; }
      function de(v, d) { var s = v.toFixed(d || 0).replace('.', ','); return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
      function sel(list) { return list.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || list[0]; }
      function calc() {
        var p = sel(rows.p), g = sel(rows.g), r = sel(rows.r); if (!p || !g || !r) return;
        var need = num(p.getAttribute('data-kcal')), ex = String(g.getAttribute('data-extra') || '').trim();
        var extra = /%$/.test(ex) ? Math.round(need * num(ex) / 100 / 10) * 10 : num(ex);
        var pTarget = num(g.getAttribute('data-protein'));
        var ml = num(r.getAttribute('data-ml')), kcal = num(r.getAttribute('data-kcal')), prot = num(r.getAttribute('data-protein')), sug = num(r.getAttribute('data-sugar'));
        if (!kcal) return;
        /* "mind" (Leitlinie: mindestens) rundet auf, sonst kaufmaennisch; nie unter einer Flasche */
        var x = extra / kcal, count = Math.max(1, g.getAttribute('data-mode') === 'mind' ? Math.ceil(x - 0.05) : Math.round(x));
        var hasSugar = String(r.getAttribute('data-sugar') || '').trim() !== '';
        var tot = count * kcal, totP = count * prot, totS = count * sug, totMl = count * ml;
        if (n) n.textContent = String(count);
        if (unit) unit.textContent = count === 1 ? 'Flasche pro Tag' : 'Flaschen pro Tag';
        if (out.energy) out.energy.textContent = de(tot) + ' kcal' + (extra ? ' (Ziel ' + de(extra) + ')' : '');
        if (out.volume) out.volume.textContent = de(totMl) + ' ml';
        if (out.protein) {
          var ok = !pTarget || totP >= pTarget;
          out.protein.innerHTML = de(totP, totP % 1 ? 1 : 0) + ' g' + (pTarget ? ' von ' + de(pTarget) + ' g Ziel' : '') + '<i data-status="' + (ok ? 'ok' : 'short') + '"></i>';
        }
        if (out.sugar) out.sugar.textContent = hasSugar ? de(totS, totS % 1 ? 1 : 0) + ' g' : 'keine Herstellerangabe';
        if (out.share) out.share.textContent = need ? Math.round(tot / need * 100) + ' % von ' + de(need) + ' kcal' : '';
        if (txt) {
          var gt = g.getAttribute('data-text') || '', rt = r.getAttribute('data-text') || '';
          txt.innerHTML = (gt ? '<b>' + g.textContent.trim() + ':</b> ' + gt + ' ' : '') + (rt ? '<b>' + r.textContent.trim() + ':</b> ' + rt : '');
        }
      }
      ['p', 'g', 'r'].forEach(function (k) {
        rows[k].forEach(function (b) {
          b.addEventListener('click', function () { rows[k].forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); calc(); });
        });
      });
      calc();
    });
  }

  /* Mahlzeiten-Tausch (Mahlzeitenersatz): Bedarf (eine Wahl) minus ersetzte Mahlzeiten (Mehrfachwahl) plus Produkt-kcal = Tagesdefizit;
     Abnahme rechnerisch mit 7.000 kcal je kg, gedeckelt auf 1 kg je Woche (Leitlinien-Korridor), Untergrenze je Profil warnt */
  function swap() {
    qa('[data-rg-swap]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var profs = qa('[data-rg-swap-profiles] button', w), meals = qa('[data-rg-swap-meals] button', w), prods = qa('[data-rg-swap-products] button', w);
      var n = q('[data-rg-swap-n]', w), txt = q('[data-rg-swap-text]', w), res = q('[data-rg-swap-result]', w);
      var out = { deficit: q('[data-rg-swap-deficit]', w), intake: q('[data-rg-swap-intake]', w), w12: q('[data-rg-swap-12w]', w), mode: q('[data-rg-swap-mode]', w) };
      var t = { none: w.getAttribute('data-text-0') || '', low: w.getAttribute('data-text-low') || '', ok: w.getAttribute('data-text-ok') || '', all: w.getAttribute('data-text-all') || '', min: w.getAttribute('data-text-min') || '', gain: w.getAttribute('data-text-gain') || '' };
      function num(s) { return parseFloat(String(s || '').replace(',', '.')) || 0; }
      function de(v, d) { var s = v.toFixed(d || 0).replace('.', ','); return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
      function sel(list) { return list.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || list[0]; }
      function calc() {
        var p = sel(profs), pr = sel(prods); if (!p || !pr) return;
        var need = num(p.getAttribute('data-kcal')), min = num(p.getAttribute('data-min')), shake = num(pr.getAttribute('data-kcal'));
        var on = meals.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; });
        var saved = on.reduce(function (a, b) { return a + (num(b.getAttribute('data-kcal')) - shake); }, 0);
        var intake = need - saved, deficit = Math.max(0, saved);
        var perWeek = deficit * 7 / 7000, capped = Math.min(perWeek, 1);
        var kg2 = capped * 2, kg12 = capped * 12;
        if (n) n.textContent = (on.length ? '−' : '') + de(kg2, 1);
        if (out.deficit) out.deficit.textContent = saved < 0 ? '+' + de(-saved) + ' kcal' : de(deficit) + ' kcal';
        if (out.intake) out.intake.innerHTML = de(intake) + ' von ' + de(need) + ' kcal' + '<i data-status="' + (min && intake < min ? 'short' : 'ok') + '"></i>';
        if (out.w12) out.w12.textContent = on.length && saved > 0 ? 'rund ' + de(kg12, 1) + ' kg' + (perWeek > 1 ? ' (gedeckelt auf 1 kg je Woche)' : '') : '0 kg';
        if (out.mode) out.mode.textContent = !on.length ? 'keine Mahlzeit ersetzt' : on.length === 1 ? 'eine Mahlzeit ersetzt: Gewicht halten' : on.length >= meals.length && meals.length >= 3 ? 'alle Mahlzeiten ersetzt: Tagesration, nur mit Arzt' : 'zwei Mahlzeiten ersetzt: Gewichtsabnahme';
        if (res) res.classList.toggle('rg-swap--warn', !!(on.length && ((min && intake < min) || saved < 0)));
        if (txt) {
          var pt = pr.getAttribute('data-text') || '', body;
          if (!on.length) body = t.none;
          else if (saved <= 0) body = t.gain;
          else if (min && intake < min) body = t.min;
          else if (on.length >= meals.length && meals.length >= 3) body = t.all;
          else if (on.length === 1) body = t.low;
          else body = t.ok;
          body = String(body).replace('{kg2}', de(kg2, 1)).replace('{kg12}', de(kg12, 1)).replace('{deficit}', de(deficit)).replace('{intake}', de(intake)).replace('{min}', de(min));
          txt.innerHTML = body + (pt ? ' <b>' + pr.textContent.trim() + ':</b> ' + pt : '');
        }
      }
      profs.forEach(function (b) { b.addEventListener('click', function () { profs.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); calc(); }); });
      prods.forEach(function (b) { b.addEventListener('click', function () { prods.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); calc(); }); });
      meals.forEach(function (b) { b.addEventListener('click', function () { b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); calc(); }); });
      calc();
    });
  }

  /* Ziel-Rechner (Abnehmen, 14.10.2026): Faustregel (kcal je kg, statisch) gegen ein vereinfachtes dynamisches
     Modell nach Hall 2011, bei dem der Tagesverbrauch je verlorenem Kilogramm um `adapt` kcal sinkt. Wochenweise
     Simulation: wirksames Defizit = Defizit - adapt x bisher verloren; Abbruch, wenn das Ziel erreicht ist,
     das wirksame Defizit auf null faellt oder max_weeks um sind. */
  function goal() {
    qa('[data-rg-goal]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var goals = qa('[data-rg-goal-goals] button', w), defs = qa('[data-rg-goal-deficits] button', w), inp = q('[data-rg-goal-input]', w);
      var goalGroup = q('[data-rg-goal-goals]', w), defGoal = goalGroup ? goalGroup.getAttribute('data-default') : '';
      var n = q('[data-rg-goal-n]', w), unit = q('[data-rg-goal-unit]', w), txt = q('[data-rg-goal-text]', w), res = q('[data-rg-goal-result]', w);
      var out = { lin: q('[data-rg-goal-lin]', w), real: q('[data-rg-goal-real]', w), start: q('[data-rg-goal-start]', w), end: q('[data-rg-goal-end]', w) };
      function num(s) { return parseFloat(String(s || '').replace(',', '.')) || 0; }
      function de(v, d) { var s = v.toFixed(d || 0).replace('.', ','); return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
      function sel(list) { return list.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || list[0]; }
      var kcalKg = num(w.getAttribute('data-kcal-kg')) || 7000, adapt = num(w.getAttribute('data-adapt')) || 24;
      var maxW = parseInt(w.getAttribute('data-max-weeks'), 10) || 104, fastFrom = num(w.getAttribute('data-fast-from')) || 700;
      var units = { ok: w.getAttribute('data-unit') || '', never: w.getAttribute('data-unit-never') || '' };
      var t = { ok: w.getAttribute('data-text-ok') || '', slow: w.getAttribute('data-text-slow') || '', never: w.getAttribute('data-text-never') || '', fast: w.getAttribute('data-text-fast') || '' };
      function months(wk) { var m = wk / 4.345; return m < 1.5 ? 'rund ' + de(Math.max(1, Math.round(m))) + ' Monat' : 'rund ' + de(Math.round(m)) + ' Monate'; }
      function calc() {
        var d = sel(defs); if (!d) return;
        var typed = inp && inp.value !== '' ? num(inp.value) : 0, maxIn = inp ? num(inp.getAttribute('max')) || 80 : 80;
        var goalKg = typed > 0 ? Math.min(maxIn, Math.max(0.5, typed)) : (sel(goals) ? num(sel(goals).getAttribute('data-kg')) : 0);
        var deficit = num(d.getAttribute('data-kcal')); if (!goalKg || !deficit) return;
        var goalTxt = de(goalKg, goalKg % 1 ? 1 : 0);
        var lin = goalKg * kcalKg / (deficit * 7);
        var rateStart = deficit * 7 / kcalKg, rateEnd = rateStart, lost = 0, weeks = 0, reached = false;
        while (weeks < maxW) {
          var eff = deficit - adapt * lost; if (eff <= 0) break;
          rateEnd = eff * 7 / kcalKg; lost += rateEnd; weeks++;
          if (lost >= goalKg) { reached = true; weeks -= (lost - goalKg) / rateEnd; break; }
        }
        var real = Math.max(1, Math.round(weeks)), linR = Math.max(1, Math.round(lin));
        if (n) n.textContent = reached ? de(real) : de(Math.round(maxW / 52)) + '+';
        if (unit) unit.textContent = reached ? units.ok : units.never;
        if (out.lin) out.lin.textContent = de(linR) + (linR === 1 ? ' Woche' : ' Wochen');
        if (out.real) out.real.textContent = reached ? 'etwa ' + de(real) + (real === 1 ? ' Woche' : ' Wochen') + ' (' + months(real) + ')' : 'nicht in ' + de(maxW) + ' Wochen';
        if (out.start) out.start.textContent = de(rateStart, 2) + ' kg je Woche';
        if (out.end) out.end.textContent = (reached ? de(rateEnd, 2) : '0,00') + ' kg je Woche';
        if (res) res.classList.toggle('rg-goal--warn', !reached || deficit >= fastFrom);
        if (txt) {
          var body = !reached ? t.never : deficit >= fastFrom ? t.fast : rateEnd < rateStart * 0.6 ? t.slow : t.ok;
          body = String(body).replace(/\{goal\}/g, goalTxt).replace(/\{deficit\}/g, de(deficit)).replace(/\{lin\}/g, de(linR)).replace(/\{real\}/g, de(real))
            .replace(/\{months\}/g, months(real)).replace(/\{start\}/g, de(rateStart, 2)).replace(/\{end\}/g, de(reached ? rateEnd : 0, 2))
            .replace(/\{adapt\}/g, de(Math.round(adapt * Math.min(lost, goalKg)))).replace(/\{maxmonths\}/g, de(Math.round(maxW / 4.345)));
          var dt = d.getAttribute('data-text') || '';
          txt.innerHTML = body + (dt ? ' <b>' + d.textContent.trim() + ':</b> ' + dt : '');
        }
      }
      goals.forEach(function (b) { b.addEventListener('click', function () { if (inp) inp.value = ''; goals.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); calc(); }); });
      defs.forEach(function (b) { b.addEventListener('click', function () { defs.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); calc(); }); });
      if (inp) inp.addEventListener('input', function () {
        /* genaue Eingabe gewinnt: Chips abwaehlen; leeres Feld faellt auf den vorausgewaehlten Chip zurueck (Gregor 14.10.2026) */
        var on = inp.value !== '' && num(inp.value) > 0;
        goals.forEach(function (x) { x.setAttribute('aria-pressed', !on && x.getAttribute('data-kg') === defGoal ? 'true' : 'false'); });
        calc();
      });
      calc();
    });
  }

  /* Kalorienrechner (Kalorienrechner-Artikel 14.10.2026): Mifflin-St Jeor 1990 (10 kg + 6,25 cm - 5 Jahre +5 / -161) x DGE-PAL
     (+0,3 bei Sport), Ziel Abnehmen = minus Defizit (nie unter den Ruheumsatz), Muskelaufbau = plus Prozent, Protein g/kg je Ziel
     (ab 65 Jahren mindestens 1,0), Spanne +/-10 % (Frankenfield). Unter 18 oder BMI < 18,5 beim Abnehmen: Hinweis statt Zahl. */
  function kcal() {
    qa('[data-rg-kcal]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var sexB = qa('[data-rg-kcal-sex] button', w), actB = qa('[data-rg-kcal-act] button', w), goalB = qa('[data-rg-kcal-goal] button', w), sport = q('[data-rg-kcal-sport]', w);
      var age = q('[data-rg-kcal-age]', w), hgt = q('[data-rg-kcal-height]', w), wgt = q('[data-rg-kcal-weight]', w);
      var out = { bmr: q('[data-rg-kcal-bmr]', w), tdee: q('[data-rg-kcal-tdee]', w), target: q('[data-rg-kcal-target]', w), tlbl: q('[data-rg-kcal-targetlbl]', w),
        range: q('[data-rg-kcal-range]', w), pal: q('[data-rg-kcal-pal]', w), prot: q('[data-rg-kcal-protein]', w), txt: q('[data-rg-kcal-text]', w), act: q('[data-rg-kcal-acttext]', w), res: q('[data-rg-kcal-result]', w) };
      var deficit = parseFloat(w.getAttribute('data-deficit')) || 500, surplus = parseFloat(w.getAttribute('data-surplus')) || 10, surplusMore = parseFloat(w.getAttribute('data-surplus-more')) || 15;
      var pf = { lose: parseFloat(w.getAttribute('data-p-lose')) || 1.2, keep: parseFloat(w.getAttribute('data-p-keep')) || 0.8, gain: parseFloat(w.getAttribute('data-p-gain')) || 1.6, more: parseFloat(w.getAttribute('data-p-more')) || 1.0 };
      var t = {}; ['lose', 'keep', 'gain', 'more', 'min', 'low', 'young', 'under'].forEach(function (k) { t[k] = w.getAttribute('data-text-' + k) || ''; });
      var tlbl0 = out.tlbl ? out.tlbl.textContent : '';
      var lbl = { lose: w.getAttribute('data-lbl-lose') || 'Abnehmen', more: w.getAttribute('data-lbl-more') || 'Zunehmen', gain: w.getAttribute('data-lbl-gain') || 'Muskelaufbau' };
      function num(el, d) { var v = parseFloat(String(el && el.value || '').replace(',', '.')); return isFinite(v) ? v : d; }
      function de(v) { return String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
      function sel(list) { return list.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || list[0]; }
      function fill(s, m) { return String(s).replace(/\{(\w+)\}/g, function (_, k) { return m[k] != null ? m[k] : ''; }); }
      function calc() {
        var sx = sel(sexB), ac = sel(actB), gl = sel(goalB); if (!sx || !ac || !gl) return;
        var a = Math.min(100, Math.max(0, num(age, 35))), h = Math.min(230, Math.max(130, num(hgt, 168))), kg = Math.min(300, Math.max(35, num(wgt, 68)));
        var male = sx.getAttribute('data-sex') === 'm', goal = gl.getAttribute('data-goal') || 'keep';
        var pal = (parseFloat(ac.getAttribute('data-pal')) || 1.4) + (sport && sport.getAttribute('aria-pressed') === 'true' ? 0.3 : 0);
        pal = Math.round(pal * 10) / 10;
        var bmr = Math.round(10 * kg + 6.25 * h - 5 * a + (male ? 5 : -161)), tdee = Math.round(bmr * pal), lo = Math.round(tdee * 0.9), hi = Math.round(tdee * 1.1);
        var bmi = kg / Math.pow(h / 100, 2), target = tdee, clamped = false;
        if (goal === 'lose') { target = tdee - deficit; if (target < bmr) { target = bmr; clamped = true; } }
        else if (goal === 'gain') target = Math.round(tdee * (1 + surplus / 100));
        else if (goal === 'more') target = Math.round(tdee * (1 + surplusMore / 100));
        var pfac = pf[goal] || 0.8; if (a >= 65 && pfac < 1) pfac = 1;
        var prot = Math.round(kg * pfac);
        var m = { bmr: de(bmr), tdee: de(tdee), target: de(target), lo: de(lo), hi: de(hi), protein: de(prot), pal: String(pal).replace('.', ','), deficit: de(deficit), surplus: String(goal === 'more' ? surplusMore : surplus), real: de(tdee - target) };
        var young = a < 18, under = goal === 'lose' && bmi < 18.5, warn = young || under || clamped || (goal === 'lose' && target < 1200);
        if (out.act) out.act.textContent = ac.getAttribute('data-text') || '';
        if (out.bmr) out.bmr.textContent = young ? '–' : m.bmr;
        if (out.tdee) out.tdee.textContent = young ? '–' : m.tdee;
        if (out.target) out.target.textContent = (young || under) ? '–' : m.target;
        if (out.tlbl) out.tlbl.textContent = lbl[goal] || tlbl0;
        if (out.range) out.range.textContent = young ? '–' : m.lo + ' bis ' + m.hi + ' kcal';
        if (out.pal) out.pal.textContent = m.pal;
        if (out.prot) out.prot.textContent = young ? '–' : m.protein + ' g';
        if (out.res) out.res.classList.toggle('rg-kcal--warn', warn);
        if (out.txt) {
          var body;
          if (young) body = t.young;
          else if (under) body = t.under;
          else if (clamped) body = t.min;
          else if (goal === 'lose' && target < 1200) body = t.low;
          else body = t[goal] || '';
          out.txt.textContent = fill(body, m);
        }
      }
      function pick(list, b) { list.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); calc(); }
      sexB.forEach(function (b) { b.addEventListener('click', function () { pick(sexB, b); }); });
      actB.forEach(function (b) { b.addEventListener('click', function () { pick(actB, b); }); });
      goalB.forEach(function (b) { b.addEventListener('click', function () { pick(goalB, b); }); });
      if (sport) sport.addEventListener('click', function () { sport.setAttribute('aria-pressed', sport.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); calc(); });
      [age, hgt, wgt].forEach(function (el) { if (el) { el.addEventListener('input', calc); el.addEventListener('change', calc); } });
      calc();
    });
  }

  /* Entscheider: Antwort-Buttons tragen data-next (q2, q3, r1 ...), nur ein Schritt sichtbar */
  function decider() {
    qa('[data-rg-decider]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var steps = qa('[data-rg-decider-step]', w), first = steps[0];
      function show(id) {
        var hit = false;
        steps.forEach(function (s) { var on = s.getAttribute('data-rg-decider-step') === id; s.hidden = !on; if (on) hit = true; });
        if (!hit && first) { steps.forEach(function (s) { s.hidden = s !== first; }); }
      }
      qa('.rg-decider__answers button', w).forEach(function (b) {
        b.addEventListener('click', function () { show(String(b.getAttribute('data-next') || '').trim()); });
      });
      qa('[data-rg-decider-reset]', w).forEach(function (b) { b.addEventListener('click', function () { if (first) show(first.getAttribute('data-rg-decider-step')); }); });
    });
  }

  /* Symptom-Finder (Vitaminmangel-Übersicht 02.10.2026): Reiter wechseln den Modus, ein Chip blendet sein Ergebnis-Set ein.
     Alle Sets stehen im HTML, hier wird nur hidden gesetzt; zweiter Klick auf den Chip hebt die Auswahl auf. */
  function finder() {
    qa('[data-rg-finder]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var tabs = qa('[data-rg-finder-tab]', w), modes = qa('[data-rg-finder-mode]', w);
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var id = t.getAttribute('data-rg-finder-tab');
          tabs.forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
          modes.forEach(function (m) { m.hidden = m.getAttribute('data-rg-finder-mode') !== id; });
        });
      });
      modes.forEach(function (m) {
        var chips = qa('.rg-finder__chips button', m), sets = qa('.rg-finder__set', m), start = q('[data-rg-finder-start]', m);
        function show(id) {
          chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-chip') === id ? 'true' : 'false'); });
          sets.forEach(function (s) { s.hidden = s.getAttribute('data-chip') !== id; });
          if (start) start.hidden = !!id;
        }
        chips.forEach(function (c) {
          c.addEventListener('click', function () { show(c.getAttribute('aria-pressed') === 'true' ? '' : c.getAttribute('data-chip')); });
        });
      });
    });
  }

  /* Skala (Kiefersperre 21.09.2026, seit 22.09.2026 mit Einheit/Dezimalen): Buttons tragen data-mm (oder "lock"), Eingabefeld in data-unit; Zone = erste mit data-to >= Wert */
  function scale() {
    qa('[data-rg-scale]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var max = parseFloat(w.getAttribute('data-max') || '60') || 60;
      /* Achsen-Untergrenze (Chloridmangel 02.10.2026): data-min, Standard 0; lineare Position = (Wert - min) / (max - min) */
      var min = parseFloat(w.getAttribute('data-min') || '0') || 0;
      if (min >= max) min = 0;
      /* Log-Achse (Vitamin B6 30.09.2026): Position = ln(1+Wert)/ln(1+max), Zonenbreiten und Ticks werden hier gesetzt */
      var islog = w.getAttribute('data-log') === '1';
      function pos(v) { return islog ? Math.log1p(Math.max(0, v)) / Math.log1p(max) : (v - min) / (max - min); }
      var unit = w.getAttribute('data-unit') || 'mm', step = parseFloat(w.getAttribute('data-step') || '1') || 1;
      var dec = step < 1 ? String(step).split('.')[1].length : 0;
      /* Einheiten-Umschalter (Phosphatmangel 23.09.2026): Eingabe wahlweise in data-unit-alt, Wert = Eingabe / data-factor; Ergebnis nennt beide Einheiten */
      var alt = w.getAttribute('data-unit-alt') || '', factor = parseFloat(w.getAttribute('data-factor') || '0') || 0, useAlt = false;
      function fmt(n) { return n.toFixed(dec).replace('.', ',') + ' ' + unit; }
      function both(n) { return fmt(n) + (alt && factor ? ' (' + (n * factor).toFixed(1).replace('.', ',') + ' ' + alt + ')' : ''); }
      var btns = qa('.rg-scale__btns button', w), inp = q('[data-rg-scale-input]', w), pin = q('[data-rg-scale-pin]', w), val = q('[data-rg-scale-val]', w);
      var txt = q('[data-rg-scale-text]', w), zones = qa('.rg-scale__zone', w), tpl = q('[data-rg-scale-texts]', w), ubtns = qa('.rg-scale__units button', w);
      var texts = tpl ? qa('div', tpl.content || tpl) : [];
      if (islog) {
        var prev = 0;
        zones.forEach(function (z) { var to = parseFloat(z.getAttribute('data-to') || '0') || 0; z.style.width = ((pos(to) - pos(prev)) * 100) + '%'; prev = to; });
        qa('[data-tick]', w).forEach(function (t) { var pc = pos(parseFloat(t.getAttribute('data-tick') || '0') || 0) * 100; t.style.left = pc + '%'; t.style.transform = pc < 4 ? 'none' : (pc > 96 ? 'translateX(-100%)' : 'translateX(-50%)'); });
      }
      function set(mm, lock) {
        zones.forEach(function (z) { z.classList.remove('rg-on'); });
        if (lock) { if (pin) pin.hidden = true; if (txt) txt.innerHTML = w.getAttribute('data-text-lock') || ''; return; }
        var v = Math.max(min, Math.min(max, mm)), hit = -1;
        if (pin) { pin.hidden = false; pin.style.left = (pos(v) * 100) + '%'; }
        if (val) val.textContent = fmt(mm);
        for (var i = 0; i < zones.length; i++) { if (v <= parseFloat(zones[i].getAttribute('data-to') || '0')) { hit = i; break; } }
        if (hit < 0) hit = zones.length - 1;
        if (zones[hit]) zones[hit].classList.add('rg-on');
        if (txt) txt.innerHTML = '<span class="rg-n">' + both(mm) + '</span>' + (texts[hit] ? texts[hit].innerHTML : '');
      }
      function fromInput() {
        var v = parseFloat(String(inp.value).replace(',', '.')); if (isNaN(v)) return;
        if (useAlt && factor) v = v / factor;
        btns.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        set(v, false);
      }
      ubtns.forEach(function (b) {
        b.addEventListener('click', function () {
          useAlt = b.getAttribute('data-u') === 'alt';
          ubtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          if (inp) { inp.placeholder = useAlt ? alt : unit; inp.max = useAlt ? String(Math.round(parseFloat(inp.getAttribute('max') || '0') * factor * 10) / 10) : inp.getAttribute('max'); if (inp.value) fromInput(); }
        });
      });
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          var mm = String(b.getAttribute('data-mm') || '').trim();
          if (inp) inp.value = '';
          if (mm === 'lock') set(0, true); else set(parseFloat(mm.replace(',', '.')) || 0, false);
        });
      });
      if (inp) inp.addEventListener('input', fromInput);
    });
  }

  /* Abend-Uhr (Sodbrennen 22.09.2026): Schlafenszeit aus Buttons (data-time "HH:MM") oder Zeitfeld; jede Regel (data-h Stunden vorher)
     bekommt ihre Uhrzeit, Punkte auf dem Zeitstrahl liegen bei (span - h) / span */
  function clock() {
    qa('[data-rg-clock]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var span = parseFloat(w.getAttribute('data-span') || '6') || 6;
      var btns = qa('.rg-clock__btns button', w), inp = q('[data-rg-clock-input]', w), dots = qa('[data-rg-clock-dot]', w);
      var rows = qa('[data-rg-clock-rules] li', w), txt = q('[data-rg-clock-text]', w), tpl = q('[data-rg-clock-result]', w), ticks = qa('[data-rg-clock-tick]', w);
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function fmt(mins) { mins = ((mins % 1440) + 1440) % 1440; return pad(Math.floor(mins / 60)) + ':' + pad(mins % 60); }
      function parse(s) { var m = /^(\d{1,2}):(\d{2})$/.exec(String(s || '').trim()); return m ? (parseInt(m[1], 10) % 24) * 60 + parseInt(m[2], 10) : NaN; }
      function set(bed) {
        if (isNaN(bed)) return;
        rows.forEach(function (li) { var h = parseFloat(li.getAttribute('data-h') || '0') || 0; var t = q('[data-rg-clock-time]', li); if (t) t.textContent = fmt(Math.round(bed - h * 60)); });
        dots.forEach(function (d) {
          var h = parseFloat(d.getAttribute('data-h') || '0') || 0, pct = Math.max(0, Math.min(100, (span - h) / span * 100));
          d.style.left = pct + '%'; d.classList.add('rg-on');
          d.classList.toggle('rg-clock__dot--end', pct > 82); d.classList.toggle('rg-clock__dot--start', pct < 18);
        });
        ticks.forEach(function (t) { var h = parseFloat(t.getAttribute('data-rg-clock-tick') || '0') || 0; t.textContent = fmt(Math.round(bed - h * 60)); });
        if (txt && tpl) txt.innerHTML = (tpl.innerHTML || '').replace(/\{bed\}/g, '<span class="rg-n">' + fmt(bed) + '</span>');
        w.classList.add('rg-clock--set');
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          if (inp) inp.value = '';
          set(parse(b.getAttribute('data-time')));
        });
      });
      if (inp) inp.addEventListener('input', function () { var v = parse(inp.value); if (isNaN(v)) return; btns.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); set(v); });
      var def = w.getAttribute('data-default');
      if (def) {
        var hit = btns.filter(function (b) { return String(b.getAttribute('data-time') || '').trim() === def; })[0];
        if (hit) hit.setAttribute('aria-pressed', 'true');
        set(parse(def));
      }
    });
  }

  /* Fastenfenster-Planer (Intervallfasten 19.10.2026): Methode (Fastenstunden) x Variante (erste oder letzte Mahlzeit vorgeben)
     x Uhrzeit x Schlafenszeit -> 24-h-Leiste (Essen Themenfarbe, Schlaf schraffiert), zwei grosse Uhrzeiten, Schlafanteil der
     Fastenzeit, Abstand letzte Mahlzeit zu Schlaf; Hinweise ab data-long-from Fastenstunden und unter data-gap-min Stunden. */
  function fastwin() {
    qa('[data-rg-fastwin]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var methods = qa('[data-rg-fw-methods] button', w), variants = qa('[data-rg-fw-variants] button', w);
      var rows = { a: q('[data-rg-fw-time="a"]', w), b: q('[data-rg-fw-time="b"]', w), s: q('[data-rg-fw-time="s"]', w) };
      var sleepH = parseFloat(w.getAttribute('data-sleep-hours') || '8') || 8, gapMin = parseFloat(w.getAttribute('data-gap-min') || '3') || 3, longFrom = parseFloat(w.getAttribute('data-long-from') || '18') || 18;
      var eat = [q('[data-rg-fw-eat="1"]', w), q('[data-rg-fw-eat="2"]', w)], sl = [q('[data-rg-fw-sl="1"]', w), q('[data-rg-fw-sl="2"]', w)];
      var out = { start: q('[data-rg-fw-start]', w), end: q('[data-rg-fw-end]', w), eatH: q('[data-rg-fw-eat-h]', w), fastH: q('[data-rg-fw-fast-h]', w), sleepH: q('[data-rg-fw-sleep-h]', w), gapH: q('[data-rg-fw-gap-h]', w) };
      var txt = q('[data-rg-fw-text]', w), tpl = q('[data-rg-fw-tpl]', w), late = q('[data-rg-fw-late]', w), lng = q('[data-rg-fw-long]', w), hint = q('[data-rg-fw-method-hint]', w), res = q('[data-rg-fw-result]', w);
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function fmt(m) { m = ((m % 1440) + 1440) % 1440; return pad(Math.floor(m / 60)) + ':' + pad(m % 60); }
      function parse(s) { var r = /^(\d{1,2}):(\d{2})$/.exec(String(s || '').trim()); return r ? (parseInt(r[1], 10) % 24) * 60 + parseInt(r[2], 10) : NaN; }
      function de(v) { return (Math.round(v * 10) / 10).toString().replace('.', ','); }
      function sel(list) { return list.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || list[0]; }
      function timeOf(row) {
        if (!row) return NaN;
        var inp = q('[data-rg-fw-input]', row), v = inp ? parse(inp.value) : NaN;
        if (!isNaN(v)) return v;
        var b = sel(qa('[data-rg-fw-times] button', row)); return b ? parse(b.getAttribute('data-time')) : NaN;
      }
      function seg(els, from, len) {
        /* Abschnitt auf der 24-h-Achse, bei Ueberlauf zwei Teile */
        from = ((from % 1440) + 1440) % 1440;
        var a = Math.min(len, 1440 - from), b = len - a;
        if (els[0]) { els[0].style.left = (from / 14.4) + '%'; els[0].style.width = (a / 14.4) + '%'; }
        if (els[1]) { els[1].style.left = '0%'; els[1].style.width = (b > 0 ? b / 14.4 : 0) + '%'; }
      }
      function variant() { var b = sel(variants); return b ? b.getAttribute('data-variant') : 'a'; }
      function calc() {
        var m = sel(methods), fastH = m ? parseFloat(m.getAttribute('data-fast')) || 16 : 16, eatH = 24 - fastH, v = variant();
        var start, end, t = timeOf(rows[v]), bed = timeOf(rows.s);
        if (isNaN(t) || isNaN(bed)) return;
        if (v === 'b') { end = t; start = ((t - eatH * 60) % 1440 + 1440) % 1440; } else { start = t; end = (t + eatH * 60) % 1440; }
        /* Schlafanteil: Fasten von end bis start(+24h), Schlaf von bed bis bed+sleepH, auf 48 h vergleichen */
        var f0 = end, f1 = start <= end ? start + 1440 : start, ov = 0;
        for (var k = -1; k < 2; k++) { var s0 = bed + k * 1440, s1 = s0 + sleepH * 60, lo = Math.max(f0, s0), hi = Math.min(f1, s1); if (hi > lo) ov += hi - lo; }
        var gap = ((bed - end) % 1440 + 1440) % 1440;
        seg(eat, start, eatH * 60); seg(sl, bed, sleepH * 60);
        if (out.start) out.start.textContent = fmt(start);
        if (out.end) out.end.textContent = fmt(end);
        if (out.eatH) out.eatH.textContent = de(eatH) + ' Std.';
        if (out.fastH) out.fastH.textContent = de(fastH) + ' Std.';
        if (out.sleepH) out.sleepH.textContent = de(ov / 60) + ' Std.';
        if (out.gapH) out.gapH.textContent = de(gap / 60) + ' Std.';
        if (txt && tpl) txt.innerHTML = (tpl.innerHTML || '').replace(/\{start\}/g, fmt(start)).replace(/\{end\}/g, fmt(end)).replace(/\{eat\}/g, de(eatH)).replace(/\{fast\}/g, de(fastH)).replace(/\{sleep\}/g, de(ov / 60)).replace(/\{gap\}/g, de(gap / 60));
        var isLate = gap < gapMin * 60 || gap > 16 * 60, isLong = fastH >= longFrom;
        if (late) late.hidden = !isLate;
        if (lng) lng.hidden = !isLong;
        if (res) res.classList.toggle('rg-fastwin--warn', isLate || isLong);
        if (hint && m) hint.textContent = m.getAttribute('data-hint') || '';
      }
      methods.forEach(function (b) { b.addEventListener('click', function () { methods.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); calc(); }); });
      variants.forEach(function (b) { b.addEventListener('click', function () {
        variants.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var v = b.getAttribute('data-variant'); if (rows.a) rows.a.hidden = v !== 'a'; if (rows.b) rows.b.hidden = v !== 'b'; calc();
      }); });
      Object.keys(rows).forEach(function (k) {
        var row = rows[k]; if (!row) return;
        var btns = qa('[data-rg-fw-times] button', row), inp = q('[data-rg-fw-input]', row);
        btns.forEach(function (b) { b.addEventListener('click', function () { if (inp) inp.value = ''; btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); calc(); }); });
        var prev = null;
        if (inp) inp.addEventListener('input', function () {
          var v = parse(inp.value);
          if (isNaN(v)) {
            /* Feld geleert: zuletzt gewaehlte Uhrzeit wieder aktivieren, sonst rechnet sel() still mit dem ersten Chip */
            if (!String(inp.value).trim() && !btns.some(function (x) { return x.getAttribute('aria-pressed') === 'true'; })) {
              var r = prev || btns[0]; if (r) r.setAttribute('aria-pressed', 'true'); calc();
            }
            return;
          }
          var cur = btns.filter(function (x) { return x.getAttribute('aria-pressed') === 'true'; })[0]; if (cur) prev = cur;
          btns.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); calc();
        });
      });
      calc();
    });
  }

  /* Vorratsrechner (Prepper-Lebensmittel 30.09.2026): Erwachsene und Kinder als Stepper, Tage als Chips;
     jede Gruppe traegt data-per10 (kg je Person und 10 Tage), Menge = per10 x Personen x Tage / 10;
     Getraenke je Erwachsenem data-water und je Kind data-water-kid (Liter je 10 Tage), Energie data-kcal je Person und Tag */
  function stock() {
    qa('[data-rg-stock]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      function num(s) { return parseFloat(String(s || '').replace(',', '.')) || 0; }
      function de(v, d) { var s = v.toFixed(d || 0).replace('.', ','); return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
      function kg(v) { return v < 1 ? de(Math.round(v * 1000 / 10) * 10) + ' g' : v < 10 ? de(v, 1) + ' kg' : de(v) + ' kg'; }
      var water = num(w.getAttribute('data-water')) || 20, waterKid = num(w.getAttribute('data-water-kid')) || 15;
      var kcal = num(w.getAttribute('data-kcal')) || 2200, longFrom = num(w.getAttribute('data-long-from')) || 30, pack = num(w.getAttribute('data-pack')) || 9;
      var t = { s: w.getAttribute('data-text-short') || '', m: w.getAttribute('data-text-mid') || '', l: w.getAttribute('data-text-long') || '' };
      var steps = [q('[data-rg-stock-adults]', w), q('[data-rg-stock-kids]', w)];
      var dayBtns = qa('[data-rg-stock-days] button', w), rows = qa('[data-rg-stock-groups] li[data-per10]', w);
      var total = q('[data-rg-stock-total]', w), wat = q('[data-rg-stock-water]', w), en = q('[data-rg-stock-kcal]', w), ppl = q('[data-rg-stock-people]', w), txt = q('[data-rg-stock-text]', w);
      function val(st) { var o = st && q('output', st); return o ? parseInt(o.textContent, 10) || 0 : 0; }
      function days() { var b = dayBtns.filter(function (x) { return x.getAttribute('aria-pressed') === 'true'; })[0] || dayBtns[0]; return b ? num(b.getAttribute('data-days')) || 10 : 10; }
      function calc() {
        var a = val(steps[0]), k = val(steps[1]), d = days(), people = a + k, f = d / 10, sum = 0;
        rows.forEach(function (li) {
          var v = num(li.getAttribute('data-per10')) * people * f; sum += v;
          var out = q('[data-rg-stock-kg]', li); if (out) out.textContent = kg(v);
        });
        var wl = (a * water + k * waterKid) * f, packs = Math.ceil(wl / pack), e = kcal * people * d;
        if (total) { total.textContent = sum < 100 ? de(sum, 1) : de(sum); total.setAttribute('data-len', String(total.textContent.length)); }
        if (wat) wat.textContent = de(wl) + ' l' + (wl >= pack ? ' (' + packs + ' Sixpacks à 1,5 l)' : '');
        if (en) en.textContent = de(e) + ' kcal';
        if (ppl) ppl.textContent = a + (a === 1 ? ' Erwachsene:r' : ' Erwachsene') + (k ? ', ' + k + (k === 1 ? ' Kind' : ' Kinder') : '') + ', ' + de(d) + ' Tage';
        if (txt) {
          var body = d < 10 ? t.s : d < longFrom ? t.m : t.l;
          txt.innerHTML = String(body).replace(/\{people\}/g, String(people)).replace(/\{days\}/g, de(d)).replace(/\{kg\}/g, sum < 100 ? de(sum, 1) : de(sum)).replace(/\{water\}/g, de(wl)).replace(/\{packs\}/g, String(packs)).replace(/\{kcal\}/g, de(e));
          txt.hidden = !body;
        }
      }
      steps.forEach(function (st) {
        if (!st) return;
        var o = q('output', st), min = num(st.getAttribute('data-min')), max = num(st.getAttribute('data-max')) || 9, btns = qa('button', st);
        function set(v) { v = Math.max(min, Math.min(max, v)); if (o) o.textContent = String(v); btns.forEach(function (b) { b.disabled = (num(b.getAttribute('data-step')) < 0 && v <= min) || (num(b.getAttribute('data-step')) > 0 && v >= max); }); }
        btns.forEach(function (b) { b.addEventListener('click', function () { set(val(st) + num(b.getAttribute('data-step'))); calc(); }); });
        set(val(st));
      });
      dayBtns.forEach(function (b) { b.addEventListener('click', function () { dayBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); calc(); }); });
      calc();
    });
  }

  /* Einkaufsrechner (Meal Prep 19.10.2026): Personen x Mahlzeiten x Portion -> Gramm je Gruppe (roh) + gekocht, Boxen */
  function prep() {
    qa('[data-rg-prep]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      function num(s) { return parseFloat(String(s || '').replace(',', '.')) || 0; }
      function de(v, d) { var s = v.toFixed(d || 0).replace('.', ','); return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
      function gr(v) { return v >= 1000 ? de(v / 1000, v >= 10000 ? 0 : 1) + ' kg' : de(Math.round(v / 10) * 10) + ' g'; }
      var t = { s: w.getAttribute('data-text-short') || '', l: w.getAttribute('data-text-long') || '' }, shortUntil = num(w.getAttribute('data-short-until')) || 3;
      var step = q('[data-rg-prep-people]', w), mealBtns = qa('[data-rg-prep-meals] button', w), sizeBtns = qa('[data-rg-prep-sizes] button', w);
      var rows = qa('[data-rg-prep-groups] li', w), total = q('[data-rg-prep-total]', w), ppl = q('[data-rg-prep-people-out]', w), sz = q('[data-rg-prep-size-out]', w), txt = q('[data-rg-prep-text]', w);
      function pressed(btns) { return btns.filter(function (x) { return x.getAttribute('aria-pressed') === 'true'; })[0] || btns[0] || null; }
      function val() { var o = step && q('output', step); return o ? parseInt(o.textContent, 10) || 1 : 1; }
      function calc() {
        var p = val(), mb = pressed(mealBtns), sb = pressed(sizeBtns);
        var m = mb ? num(mb.getAttribute('data-meals')) || 5 : 5, col = sb ? parseInt(sb.getAttribute('data-size'), 10) || 0 : 0, boxes = p * m;
        rows.forEach(function (li) {
          var per = num(li.getAttribute(col ? 'data-large' : 'data-small')), f = num(li.getAttribute('data-factor')), v = per * boxes;
          var out = q('[data-rg-prep-g]', li), sub = q('[data-rg-prep-cooked]', li);
          if (out) out.textContent = gr(v);
          if (sub) { sub.textContent = f ? 'ergibt ca. ' + gr(v * f) + (f > 1 ? ' gekocht' : ' gegart') : ''; sub.hidden = !f; }
        });
        if (total) { total.textContent = String(boxes); total.setAttribute('data-len', String(String(boxes).length)); }
        if (ppl) ppl.textContent = p + (p === 1 ? ' Person' : ' Personen') + ', ' + m + ' Mahlzeiten je Person';
        if (sz) sz.textContent = sb ? sb.textContent.trim() : '';
        if (txt) {
          var body = m <= shortUntil ? t.s : t.l;
          txt.innerHTML = String(body).replace(/\{people\}/g, String(p)).replace(/\{meals\}/g, String(m)).replace(/\{boxes\}/g, String(boxes));
          txt.hidden = !body;
        }
      }
      if (step) {
        var o = q('output', step), min = num(step.getAttribute('data-min')) || 1, max = num(step.getAttribute('data-max')) || 8, btns = qa('button', step);
        function set(v) { v = Math.max(min, Math.min(max, v)); if (o) o.textContent = String(v); btns.forEach(function (b) { b.disabled = (num(b.getAttribute('data-step')) < 0 && v <= min) || (num(b.getAttribute('data-step')) > 0 && v >= max); }); }
        btns.forEach(function (b) { b.addEventListener('click', function () { set(val() + num(b.getAttribute('data-step'))); calc(); }); });
        set(val());
      }
      [mealBtns, sizeBtns].forEach(function (grp) {
        grp.forEach(function (b) { b.addEventListener('click', function () { grp.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); calc(); }); });
      });
      calc();
    });
  }

  /* Tages-Baukasten: Lebensmittel antippen, Summe füllt den Balken bis data-target; Presets setzen ganze Tage über data-tags */
  /* Wochenplan (_ratgeber-plan, Ernährungsplan zum Abnehmen 29.10.2026): Stufe x Vegetarisch = Variante 0..5,
     Werte liegen als data-v0..5 an jeder Mahlzeit und data-t0..5 an jedem Tag; Reiter Plan/Einkaufsliste;
     "Plan drucken" öffnet eine schlanke Druckansicht (alle Tage offen, Einkaufsliste dabei), Fallback: Body-Klasse + window.print */
  function plan() {
    qa('[data-rg-plan]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var lv = qa('[data-rg-plan-levels] button', w), veg = q('[data-rg-plan-veg]', w), hint = q('[data-rg-plan-hint]', w), cap = q('[data-rg-plan-cap]', w);
      var tabs = qa('[data-rg-plan-tab]', w), panels = qa('[data-rg-plan-panel]', w), days = qa('.rg-plan__day', w), meals = qa('.rg-plan__meal', w);
      var capOmni = w.getAttribute('data-cap-omni') || '', capVeg = w.getAttribute('data-cap-veg') || '';
      function de(v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
      function sel() { return lv.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || lv[0]; }
      function apply() {
        var b = sel(); if (!b) return;
        var isVeg = veg && veg.getAttribute('aria-pressed') === 'true', i = (parseInt(b.getAttribute('data-i'), 10) || 0) + (isVeg ? 3 : 0);
        meals.forEach(function (li) {
          var v = (li.getAttribute('data-v' + i) || '').split('|');
          var n = q('[data-rg-plan-n]', li), z = q('[data-rg-plan-z]', li), k = q('[data-rg-plan-k]', li), p = q('[data-rg-plan-p]', li), f = q('[data-rg-plan-f]', li);
          if (!v[0]) { li.hidden = true; return; }
          li.hidden = false;
          if (n) n.textContent = v[0]; if (z) z.textContent = v[1] || '';
          if (k) k.textContent = de(v[2] || ''); if (p) p.textContent = v[3] || ''; if (f) f.textContent = v[4] || '';
        });
        days.forEach(function (d) {
          var t = (d.getAttribute('data-t' + i) || '').split('|');
          var k = q('[data-rg-plan-dk]', d), p = q('[data-rg-plan-dp]', d), f = q('[data-rg-plan-df]', d);
          if (k) k.textContent = de(t[0] || ''); if (p) p.textContent = t[1] || ''; if (f) f.textContent = t[2] || '';
        });
        if (hint) hint.textContent = b.getAttribute('data-text') || '';
        if (cap) cap.innerHTML = '<b>' + b.textContent.trim() + '</b> am Tag, ' + (isVeg ? capVeg : capOmni);
      }
      lv.forEach(function (b) { b.addEventListener('click', function () { lv.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); apply(); }); });
      if (veg) veg.addEventListener('click', function () { veg.setAttribute('aria-pressed', veg.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); apply(); });
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var key = t.getAttribute('data-rg-plan-tab');
          tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-rg-plan-panel') !== key; });
        });
      });
      qa('[data-rg-plan-open]', w).forEach(function (b) { b.addEventListener('click', function () { var on = b.getAttribute('data-rg-plan-open') === '1'; days.forEach(function (d) { d.open = on; }); }); });
      var pr = q('[data-rg-plan-print]', w);
      if (pr) pr.addEventListener('click', function () {
        var title = w.getAttribute('data-print-title') || doc.title, note = w.getAttribute('data-print-note') || '';
        var c = w.cloneNode(true);
        qa('.rg-plan__tools, .rg-plan__all, .rg-plan__row, .rg-wlbl', c).forEach(function (el) { el.parentNode.removeChild(el); });
        qa('[data-rg-plan-panel]', c).forEach(function (p) { p.hidden = false; });
        qa('.rg-plan__day', c).forEach(function (d) { d.open = true; });
        var css = 'body{font-family:-apple-system,"Segoe UI",Helvetica,Arial,sans-serif;color:#232f2b;margin:18mm 14mm;font-size:12px;line-height:1.4}h1{font-size:20px;margin:0 0 4px}h4{font-size:15px;margin:0 0 4px}p{margin:0}.rg-plan__intro{color:#66746f;font-size:12px}.rg-plan__cap{margin:6px 0 10px;font-size:12px;color:#66746f}.rg-plan__cap b{color:#1d3c34}.rg-plan__day{border:1px solid #d8dcd9;border-radius:8px;margin-top:8px;break-inside:avoid;page-break-inside:avoid}summary{list-style:none;padding:7px 10px;background:#f6f5f0;display:flex;justify-content:space-between;gap:10px;align-items:baseline}summary::-webkit-details-marker{display:none}.rg-plan__dname{font-weight:700;font-size:14px}.rg-plan__dsum{font-size:11px;color:#66746f}.rg-plan__dsum b{color:#1d3c34}.rg-plan__chev{display:none}.rg-plan__dnote{padding:4px 10px 0;font-size:11px;color:#66746f}ul{list-style:none;margin:0;padding:0 10px}.rg-plan__meal{display:grid;grid-template-columns:86px 1fr auto;gap:2px 10px;padding:6px 0;border-top:1px solid #e4e7e3;align-items:start}.rg-plan__meal:first-child{border-top:0}.rg-plan__meal[hidden]{display:none}.rg-plan__slot{font-size:9px;letter-spacing:.08em;text-transform:uppercase;font-weight:600;color:#2f6f8f;display:block}.rg-plan__min{font-size:10px;color:#66746f}.rg-plan__name{display:block;font-weight:600;font-size:12px}.rg-plan__ing{display:block;font-size:11px;color:#4b5753}.rg-plan__mnote{display:block;font-size:10px;color:#2e7d4f}.rg-plan__vals{text-align:right;font-size:10px;color:#66746f;white-space:nowrap}.rg-plan__vals span{display:block}.rg-plan__vals b{font-size:12px;color:#1d3c34}.rg-plan__panel[data-rg-plan-panel=shop]{margin-top:16px;break-before:page;page-break-before:always}.rg-plan__sintro{font-size:11px;color:#66746f;margin:0 0 4px}.rg-plan__shop{padding:0;columns:2;column-gap:24px}.rg-plan__shop li{display:flex;justify-content:space-between;gap:8px;padding:3px 0;border-top:1px solid #e4e7e3;break-inside:avoid}.rg-plan__shop li.rg-plan__grp{display:block;margin-top:10px;border-top:0;font-size:10px;letter-spacing:.08em;text-transform:uppercase;color:#2f6f8f;break-after:avoid}.rg-plan__sname{font-weight:600}.rg-plan__sbuy{color:#4b5753;flex:1}.rg-plan__sneed{color:#66746f;white-space:nowrap}.rg-plan__snote{font-size:10px;color:#66746f;margin-top:8px}.rg-legal{font-size:9px;color:#66746f;margin-top:12px}.rg-foot{font-size:9px;color:#66746f;margin-top:14px;border-top:1px solid #e4e7e3;padding-top:6px}';
        var win = null;
        try { win = window.open('', '_blank'); } catch (e) { win = null; }
        if (win && win.document) {
          var d = win.document;
          d.open();
          d.write('<!doctype html><html lang="de"><head><meta charset="utf-8"><title>' + title.replace(/</g, '&lt;') + '</title><style>' + css + '</style></head><body><h1>' + title.replace(/</g, '&lt;') + '</h1>' + c.outerHTML + (note ? '<p class="rg-foot">' + note.replace(/</g, '&lt;') + ' · ' + location.href.split('#')[0] + '</p>' : '') + '</body></html>');
          d.close();
          setTimeout(function () { try { win.focus(); win.print(); } catch (e) {} }, 350);
          return;
        }
        /* Fallback ohne Popup: Seite selbst drucken, nur der Plan bleibt sichtbar (CSS @media print) */
        var was = days.map(function (dd) { return dd.open; });
        days.forEach(function (dd) { dd.open = true; });
        doc.body.classList.add('rg-print-plan');
        function back() { doc.body.classList.remove('rg-print-plan'); days.forEach(function (dd, j) { dd.open = was[j]; }); window.removeEventListener('afterprint', back); }
        window.addEventListener('afterprint', back);
        window.print();
        setTimeout(back, 1500);
      });
      apply();
    });
  }

  function builder() {
    qa('[data-rg-build]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var btns = qa('.rg-build__items button', w), presets = qa('.rg-build__presets button', w);
      var fill = q('[data-rg-build-fill]', w), sum = q('[data-rg-build-sum]', w), res = q('[data-rg-build-result]', w);
      var target = parseFloat(w.getAttribute('data-target')) || 30, mid = parseFloat(w.getAttribute('data-mid')) || target / 2;
      var t0 = w.getAttribute('data-text-0') || '', tl = w.getAttribute('data-text-low') || '', tm = w.getAttribute('data-text-mid') || '', th = w.getAttribute('data-text-high') || '';
      var unit = w.getAttribute('data-unit') || 'g'; /* Einheit aus dem Block (mg bei Manganmangel, 01.10.2026), vorher fest "g" */
      function num(b) { return parseFloat(String(b.getAttribute('data-g') || '0').replace(',', '.')) || 0; }
      function fmt(v) { return (Math.round(v * 10) / 10).toString().replace('.', ','); }
      function upd() {
        var on = btns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; });
        var total = on.reduce(function (a, b) { return a + num(b); }, 0);
        if (sum) sum.textContent = fmt(total);
        if (fill) { fill.style.width = Math.min(100, total / target * 100) + '%'; fill.classList.toggle('rg-hit', total >= target); }
        if (res) {
          var pct = Math.round(total / target * 100);
          var tag = '<span class="rg-n">' + fmt(total) + ' ' + unit + '</span>';
          if (!on.length) res.innerHTML = t0;
          else if (total < mid) res.innerHTML = tag + tl.replace('{pct}', pct);
          else if (total < target) res.innerHTML = tag + tm.replace('{pct}', pct);
          else res.innerHTML = tag + th.replace('{pct}', pct);
        }
        presets.forEach(function (p) {
          var tag2 = p.getAttribute('data-preset');
          if (!tag2) { p.setAttribute('aria-pressed', 'false'); return; }
          var exact = btns.every(function (b) { return (b.getAttribute('aria-pressed') === 'true') === (String(b.getAttribute('data-tags') || '').split(',').indexOf(tag2) > -1); });
          p.setAttribute('aria-pressed', exact ? 'true' : 'false');
        });
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); upd(); }); });
      presets.forEach(function (p) {
        p.addEventListener('click', function () {
          var tag = p.getAttribute('data-preset');
          btns.forEach(function (b) { b.setAttribute('aria-pressed', tag && String(b.getAttribute('data-tags') || '').split(',').indexOf(tag) > -1 ? 'true' : 'false'); });
          upd();
        });
      });
      upd();
    });
  }

  /* Balken: zwei Datensätze als JSON im data-Attribut, animierte Breite */
  function bars() {
    qa('[data-rg-bars]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var data; try { data = JSON.parse(w.getAttribute('data-sets') || '[]'); } catch (e) { data = []; }
      if (!data.length) return;
      var wrap = q('[data-rg-bars-list]', w), note = q('[data-rg-bars-note]', w), tg = qa('.rg-toggle button', w), unit = w.getAttribute('data-unit') || '';
      function render(i) {
        var set = data[i]; if (!set) return;
        var rows = set.rows.slice().sort(function (a, b) { return b.v - a.v; });
        var max = rows.length ? rows[0].v : 1;
        wrap.innerHTML = rows.map(function (r) {
          return '<div class="rg-bar rg-set-' + (i === 0 ? 'a' : 'b') + '"><span class="rg-l">' + r.l + '</span><span class="rg-t"><i data-w="' + (r.v / max * 100) + '"></i></span><span class="rg-v">' + String(r.v).replace('.', ',') + (unit ? ' ' + unit : '') + '</span></div>';
        }).join('');
        if (note) note.textContent = set.note || '';
        requestAnimationFrame(function () { requestAnimationFrame(function () { qa('i', wrap).forEach(function (el) { el.style.width = el.getAttribute('data-w') + '%'; }); }); });
        tg.forEach(function (b, j) { b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      }
      tg.forEach(function (b, j) { b.addEventListener('click', function () { render(j); }); });
      if (hasIO && !reduce) {
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { render(0); io.disconnect(); } }); }, { threshold: .2 });
        io.observe(w);
      } else { render(0); }
    });
  }

  /* Stapelbalken (_ratgeber-stack, Fettsäuren 14.10.2026): Breiten stehen als Inline-Style im HTML und werden beim
     ersten Sichtkontakt von 0 aus animiert; Sortier-Chips ordnen die Zeilen nach data-v<Segment> (asc/desc) um;
     der Name klappt die Notiz der Zeile auf. Ohne JS: feste Reihenfolge aus dem Brief, Notizen sichtbar. */
  function stackbars() {
    qa('[data-rg-stack]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var list = q('[data-rg-stack-list]', w), rows = list ? qa(':scope > li', list) : [], chips = qa('.rg-stack__sorts button', w);
      qa('[data-rg-stack-note]', w).forEach(function (n) { n.hidden = true; });
      qa('.rg-stack__name', w).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true', li = btn.closest('li'), n = li ? q('[data-rg-stack-note]', li) : null;
          if (!n) return;
          btn.setAttribute('aria-expanded', open ? 'false' : 'true'); n.hidden = open;
        });
      });
      function sortBy(seg, dir) {
        if (!list) return;
        rows.slice().sort(function (a, b) {
          var va = parseFloat(a.getAttribute('data-v' + seg)) || 0, vb = parseFloat(b.getAttribute('data-v' + seg)) || 0;
          return dir === 'asc' ? va - vb : vb - va;
        }).forEach(function (li) { list.appendChild(li); });
      }
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
          sortBy(c.getAttribute('data-seg') || '1', c.getAttribute('data-dir') || 'desc');
        });
      });
      var segs = qa('.rg-stack__s', w);
      if (hasIO && !reduce && segs.length) {
        segs.forEach(function (s) { s.style.width = '0%'; });
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            requestAnimationFrame(function () { segs.forEach(function (s) { s.style.width = s.getAttribute('data-w') + '%'; }); });
            io.disconnect();
          });
        }, { threshold: .15 });
        io.observe(w);
      }
    });
  }

  /* Sortenwahl: Chip setzt die Variante in allen Formularen des Produktmoduls (Karte, Rail, Leiste),
     tauscht die Packshots und den Sortennamen. Der Kauf läuft über product-form-component des Themes. */
  function flavors() {
    /* Start bei jedem Produkt-Element (Inline-Modul, Rail, Sticky-Leiste), einmal je Produkt-ID; ohne Inline-Modul (rail_only) hing die Sortenwahl sonst leer */
    var done = {};
    qa('[data-rg-product]').forEach(function (card) {
      var pid = card.getAttribute('data-rg-product');
      if (!pid || done[pid] || card.dataset.rgFlavors) return; done[pid] = true; card.dataset.rgFlavors = '1';
      var scope = qa('[data-rg-product="' + pid + '"]');
      var chips = [];
      scope.forEach(function (el) { chips = chips.concat(qa('[data-rg-flavor]', el)); });
      if (!chips.length) return;
      var sheets = [];
      scope.forEach(function (el) { sheets = sheets.concat(qa('[data-rg-sheet]', el)); });
      function toggleSheet(open) { sheets.forEach(function (s) { s.hidden = !open; }); doc.body.classList.toggle('rg-sheet-on', !!open); }
      scope.forEach(function (el) {
        qa('[data-rg-sheet-open]', el).forEach(function (o) { o.addEventListener('click', function () { toggleSheet(true); }); });
        qa('[data-rg-sheet-close]', el).forEach(function (c) { c.addEventListener('click', function () { toggleSheet(false); }); });
      });
      function select(chip) {
        var id = chip.getAttribute('data-variant-id'), title = chip.getAttribute('data-title'), img = chip.getAttribute('data-image');
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-variant-id') === id ? 'true' : 'false'); });
        scope.forEach(function (el) {
          qa('input[name="id"]', el).forEach(function (i) { i.value = id; i.disabled = false; });
          qa('[data-rg-flavor-name]', el).forEach(function (n) { n.textContent = title; });
          var hn = chip.getAttribute('data-hl-num'), hs = chip.getAttribute('data-hl-sub');
          if (hn) {
            qa('[data-rg-hl-num]', el).forEach(function (n) {
              if (n.textContent === hn) return;
              n.textContent = hn;
              var tile = n.closest('.rg-fact--hl');
              if (tile) { tile.classList.remove('rg-pulse'); void tile.offsetWidth; tile.classList.add('rg-pulse'); }
            });
            qa('[data-rg-hl-sub]', el).forEach(function (n) { n.textContent = hs || ''; });
          }
          qa('[data-rg-pimg]', el).forEach(function (im) {
            if (!img || im.getAttribute('src') === img) return;
            im.classList.add('rg-swap');
            var pre = new Image();
            pre.onload = function () { im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src = img; im.classList.remove('rg-swap'); };
            pre.src = img;
          });
        });
      }
      chips.forEach(function (c) { c.addEventListener('click', function () { select(c); if (c.closest('[data-rg-sheet]')) setTimeout(function () { toggleSheet(false); }, 180); }); });
      var on = chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; })[0] || chips[0];
      select(on);
    });
  }

  /* Anhören: ein <audio data-rg-audio>, mehrere Play-Buttons (Cover + Rail) */
  function audio() {
    var au = q('[data-rg-audio]'), plays = qa('.rg-play');
    if (!au || !plays.length) return;
    function set(on) {
      plays.forEach(function (b) {
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var pi = q('.rg-pi', b), pa = q('.rg-pa', b), sp = q('span', b);
        if (pi) pi.style.display = on ? 'none' : '';
        if (pa) pa.style.display = on ? '' : 'none';
        if (sp) sp.textContent = on ? 'Pause' : (b.getAttribute('data-label') || 'Anhören');
      });
    }
    plays.forEach(function (b) {
      if (b.dataset.rgInit) return; b.dataset.rgInit = '1';
      b.addEventListener('click', function () {
        if (au.paused) { var p = au.play(); if (p && p.then) p.then(function () { set(true); }).catch(function () {}); else set(true); }
        else { au.pause(); set(false); }
      });
    });
    au.addEventListener('ended', function () { set(false); });
    au.addEventListener('pause', function () { set(false); });
    au.addEventListener('play', function () { set(true); });
  }

  /* Teilen: Web Share API, sonst Link kopieren */
  function share() {
    qa('[data-rg-share]').forEach(function (b) {
      if (b.dataset.rgInit) return; b.dataset.rgInit = '1';
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        var url = location.href.split('#')[0], title = doc.title;
        var label = q('span', b), old = label ? label.textContent : '';
        function done(t) { if (label) { label.textContent = t; setTimeout(function () { label.textContent = old; }, 1800); } }
        if (b.getAttribute('data-rg-share') === 'whatsapp') { window.open('https://wa.me/?text=' + encodeURIComponent(title + ' ' + url), '_blank', 'noopener'); return; }
        if (navigator.share && b.getAttribute('data-rg-share') === 'native') { navigator.share({ title: title, url: url }).catch(function () {}); return; }
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { done('Link kopiert'); }).catch(function () { done(url); });
      });
    });
  }

  /* Zunehm-Rechner (Zunehmen-Artikel 14.10.2026): Ruheenergieverbrauch nach DGE-Formel (Frauen (0,047 kg - 0,01452 Jahre + 3,21) x 239,
     Männer + 1,009) x DGE-PAL (+0,3 bei Sport) = Erhaltungsbedarf, Tempo = plus Prozent, Zunahme 0,25 bis 0,5 % Körpergewicht pro Woche,
     BMI mit WHO-Bereichstext. Unter 18: Hinweis statt Zahlen; BMI < 17, ab 65 und BMI >= 25 bekommen einen Zusatzhinweis. */
  function energy() {
    qa('[data-rg-energy]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var sexB = qa('[data-rg-energy-sex] button', w), actB = qa('[data-rg-energy-act] button', w), paceB = qa('[data-rg-energy-pace] button', w), sport = q('[data-rg-energy-sport]', w);
      var age = q('[data-rg-energy-age]', w), hgt = q('[data-rg-energy-height]', w), wgt = q('[data-rg-energy-weight]', w);
      var out = { tdee: q('[data-rg-energy-tdee]', w), target: q('[data-rg-energy-target]', w), plus: q('[data-rg-energy-plus]', w), gain: q('[data-rg-energy-gain]', w),
        bmi: q('[data-rg-energy-bmi]', w), pal: q('[data-rg-energy-pal]', w), txt: q('[data-rg-energy-text]', w), note: q('[data-rg-energy-note]', w), act: q('[data-rg-energy-acttext]', w), res: q('[data-rg-energy-result]', w) };
      var t = {}; ['main', 'young', 'low', 'old', 'high'].forEach(function (k) { t[k] = w.getAttribute('data-text-' + k) || ''; });
      var bt = [1, 2, 3, 4].map(function (i) { return w.getAttribute('data-bmi-t' + i) || ''; });
      function num(el, d) { var v = parseFloat(String(el && el.value || '').replace(',', '.')); return isFinite(v) ? v : d; }
      function de(v) { return String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
      function sel(list) { return list.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || list[0]; }
      function fill(s, m) { return String(s).replace(/\{(\w+)\}/g, function (_, k) { return m[k] != null ? m[k] : ''; }); }
      function calc() {
        var sx = sel(sexB), ac = sel(actB), pc = sel(paceB); if (!sx || !ac || !pc) return;
        var a = Math.min(100, Math.max(0, num(age, 30))), h = Math.min(230, Math.max(130, num(hgt, 168))), kg = Math.min(200, Math.max(30, num(wgt, 55)));
        var male = sx.getAttribute('data-sex') === 'm', pct = parseFloat(pc.getAttribute('data-pct')) || 10;
        var pal = (parseFloat(ac.getAttribute('data-pal')) || 1.4) + (sport && sport.getAttribute('aria-pressed') === 'true' ? 0.3 : 0);
        pal = Math.round(pal * 10) / 10;
        var ree = Math.round((0.047 * kg - 0.01452 * a + 3.21 + (male ? 1.009 : 0)) * 239), tdee = Math.round(ree * pal), target = Math.round(tdee * (1 + pct / 100)), plus = target - tdee;
        var lo = Math.round(kg * 0.25) * 10, hi = Math.round(kg * 0.5) * 10, bmi = Math.round(kg / Math.pow(h / 100, 2) * 10) / 10;
        var btxt = bmi < 17 ? bt[0] : bmi < 18.5 ? bt[1] : bmi < 25 ? bt[2] : bt[3];
        var ex = plus < 200 ? 'ein Glas Vollmilch und eine Handvoll Nüsse' : plus < 320 ? 'ein Porridge mit Milch und Nussmus mehr am Tag' : plus < 450 ? 'eine Trinkmahlzeit oder ein Shake am Nachmittag' : 'ein Shake plus eine Handvoll Nüsse zusätzlich';
        var m = { tdee: de(tdee), target: de(target), plus: de(plus), pct: String(pct), gain_lo: String(lo), gain_hi: String(hi), bmi: String(bmi).replace('.', ','), pal: String(pal).replace('.', ','), example: ex };
        var young = a < 18, note = young ? '' : bmi < 17 ? t.low : a >= 65 ? t.old : bmi >= 25 ? t.high : '';
        if (out.act) out.act.textContent = ac.getAttribute('data-text') || '';
        if (out.tdee) out.tdee.textContent = young ? '–' : m.tdee;
        if (out.target) out.target.textContent = young ? '–' : m.target;
        if (out.plus) out.plus.textContent = young ? '–' : '+' + m.plus;
        if (out.gain) out.gain.textContent = young ? '–' : m.gain_lo + ' bis ' + m.gain_hi + ' g';
        if (out.bmi) { out.bmi.textContent = ''; out.bmi.appendChild(doc.createTextNode(young ? '–' : m.bmi + ' ')); if (!young) { var sp = doc.createElement('span'); sp.textContent = '(' + btxt + ')'; out.bmi.appendChild(sp); } }
        if (out.pal) out.pal.textContent = m.pal;
        if (out.txt) out.txt.textContent = young ? t.young : fill(t.main, m);
        if (out.note) { out.note.textContent = note; out.note.hidden = !note; }
        if (out.res) out.res.classList.toggle('rg-energy--warn', young || bmi < 17);
      }
      function pick(list, b) { list.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); calc(); }
      sexB.forEach(function (b) { b.addEventListener('click', function () { pick(sexB, b); }); });
      actB.forEach(function (b) { b.addEventListener('click', function () { pick(actB, b); }); });
      paceB.forEach(function (b) { b.addEventListener('click', function () { pick(paceB, b); }); });
      if (sport) sport.addEventListener('click', function () { sport.setAttribute('aria-pressed', sport.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); calc(); });
      [age, hgt, wgt].forEach(function (el) { if (el) { el.addEventListener('input', calc); el.addEventListener('change', calc); } });
      calc();
    });
  }

  /* Gewichts-Check (Mangelernährung 19.10.2026): Gewicht früher/heute, Zeitraum, Größe, Altersgruppe -> ungewollter Verlust in % und kg,
     BMI heute, Stufe unauffällig/beobachten/abklären nach DGEM-Terminologie 2013 (BMI < 18,5, ab 65 < 20, Verlust > 5 % in 3 Monaten, > 10 %)
     und GLIM 2019 (> 5 % in 6 Monaten; BMI < 20 bzw. < 22 ab 65 als Beobachtungsgrenze). Keine Diagnose, kein Produktlink. */
  function weight() {
    qa('[data-rg-weight]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var perB = qa('[data-rg-weight-period] button', w), ageB = qa('[data-rg-weight-age] button', w);
      var w0 = q('[data-rg-weight-before]', w), w1 = q('[data-rg-weight-now]', w), hgt = q('[data-rg-weight-height]', w);
      var out = { pct: q('[data-rg-weight-pct]', w), kg: q('[data-rg-weight-kg]', w), bmi: q('[data-rg-weight-bmi]', w), limit: q('[data-rg-weight-limit]', w),
        bmilimit: q('[data-rg-weight-bmilimit]', w), lvl: q('[data-rg-weight-level]', w), dot: q('[data-rg-weight-dot]', w), txt: q('[data-rg-weight-text]', w), res: q('[data-rg-weight-result]', w) };
      var t = {}, lv = {}; ['ok', 'watch', 'check', 'gain'].forEach(function (k) { t[k] = w.getAttribute('data-text-' + k) || ''; lv[k] = w.getAttribute('data-lvl-' + k) || ''; });
      var tb = { check: w.getAttribute('data-text-bmi-check') || '', watch: w.getAttribute('data-text-bmi-watch') || '' };
      var rl = { pct: w.getAttribute('data-row-pct') || '', kg: w.getAttribute('data-row-kg') || '', pctG: w.getAttribute('data-row-pct-gain') || '', kgG: w.getAttribute('data-row-kg-gain') || '' };
      var lblPct = q('[data-rg-weight-pct-lbl]', w), lblKg = q('[data-rg-weight-kg-lbl]', w);
      var ph = {}, lim = {}; [3, 6, 12].forEach(function (k) { ph[k] = w.getAttribute('data-phrase-' + k) || ''; lim[k] = w.getAttribute('data-limit-' + k) || ''; });
      function num(el, d) { var v = parseFloat(String(el && el.value || '').replace(',', '.')); return isFinite(v) ? v : d; }
      function de1(v) { return (Math.round(v * 10) / 10).toFixed(1).replace('.', ','); }
      function sel(list) { return list.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || list[0]; }
      function fill(s, m) { return String(s).replace(/\{(\w+)\}/g, function (_, k) { return m[k] != null ? m[k] : ''; }); }
      function calc() {
        var pe = sel(perB), ag = sel(ageB); if (!pe || !ag) return;
        var a = num(w0, 0), b = num(w1, 0), h = Math.min(230, Math.max(120, num(hgt, 165)));
        if (!(a > 0 && b > 0)) return;
        var per = parseFloat(pe.getAttribute('data-months')) || 3, old = ag.getAttribute('data-old') === '1';
        // Anzeige zur sicheren Seite gerundet und damit verglichen (wie Liquid): Verlust aufgerundet, BMI abgerundet
        var loss = Math.abs(a - b) < 0.05 ? 0 : a - b, pct = loss / a * 100;
        pct = loss > 0 ? Math.ceil(pct * 10 - 1e-6) / 10 : -Math.round(-pct * 10) / 10;
        var bmi = Math.floor(b / Math.pow(h / 100, 2) * 10 + 1e-6) / 10;
        var bmiLimit = old ? 20 : 18.5, watchBmi = old ? 22 : 20, level = 'ok';
        if (pct > 10) level = 'check';
        else if (pct > 5 && per <= 6) level = 'check';
        else if (bmi < bmiLimit) level = 'check';
        else if (pct > 5) level = 'watch';
        else if (pct >= 2) level = 'watch';
        else if (bmi < watchBmi) level = 'watch';
        else if (loss < 0) level = 'gain';
        var sign = loss < 0 ? '+' : '', key = per <= 3 ? 3 : per <= 6 ? 6 : 12;
        var m = { loss_kg: de1(Math.abs(loss)), loss_pct: de1(Math.abs(pct)), bmi: de1(bmi), period: ph[key], bmi_limit: String(bmiLimit).replace('.', ','), watch_bmi: String(watchBmi) };
        // Stufe nur aus dem Verlauf; ist die Gesamtstufe strenger, kommt sie vom BMI → BMI-Text
        var lossLevel = (pct > 10 || (pct > 5 && per <= 6)) ? 'check' : pct >= 2 ? 'watch' : 'ok';
        var byBmi = (level === 'check' && lossLevel !== 'check') || (level === 'watch' && lossLevel === 'ok');
        var text = (byBmi && tb[level]) ? tb[level] : t[level];
        if (out.pct) out.pct.textContent = sign + m.loss_pct + ' %';
        if (out.kg) out.kg.textContent = sign + m.loss_kg + ' kg';
        if (out.bmi) out.bmi.textContent = m.bmi;
        if (lblPct) lblPct.textContent = (loss < 0 && rl.pctG) ? rl.pctG : rl.pct;
        if (lblKg) lblKg.textContent = (loss < 0 && rl.kgG) ? rl.kgG : rl.kg;
        if (out.limit) out.limit.textContent = lim[key];
        if (out.bmilimit) out.bmilimit.textContent = 'unter ' + m.bmi_limit + ', beobachten unter ' + m.watch_bmi;
        if (out.lvl) out.lvl.textContent = lv[level];
        if (out.dot) out.dot.setAttribute('data-level', level);
        if (out.txt) out.txt.textContent = fill(text, m);
        if (out.res) { out.res.classList.toggle('rg-weight--check', level === 'check'); out.res.classList.toggle('rg-weight--watch', level === 'watch'); }
      }
      function pick(list, b) { list.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); calc(); }
      perB.forEach(function (b) { b.addEventListener('click', function () { pick(perB, b); }); });
      ageB.forEach(function (b) { b.addEventListener('click', function () { pick(ageB, b); }); });
      [w0, w1, hgt].forEach(function (el) { if (el) { el.addEventListener('input', calc); el.addEventListener('change', calc); } });
      calc();
    });
  }

  /* Taille-Check (Bauchfett-Artikel, 29.10.2026): Taillenumfang gegen IDF (80/94 cm) und S3-Leitlinie (88/102 cm),
     Taille geteilt durch Größe gegen NICE NG246 (0,5 / 0,6). Einordnung = das strengere der beiden Maße.
     Beim Wechsel des Geschlechts springt die Größe auf den jeweiligen Standard, solange niemand selbst getippt hat.
     Skala 1 hat je Geschlecht eine eigene Achse (Frau 64 bis 106, Mann 78 bis 116), Skala 2 fest 0,35 bis 0,75. */
  function waist() {
    qa('[data-rg-waist]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var sexB = qa('[data-rg-waist-sex] button', w), inW = q('[data-rg-waist-waist]', w), inH = q('[data-rg-waist-height]', w);
      var out = { val: q('[data-rg-waist-val]', w), ratio: q('[data-rg-waist-ratio]', w), zw: q('[data-rg-waist-zone-w]', w), zr: q('[data-rg-waist-zone-r]', w),
        pin: q('[data-rg-waist-pin]', w), pinval: q('[data-rg-waist-pinval]', w), rpin: q('[data-rg-waist-rpin]', w), rpinval: q('[data-rg-waist-rpinval]', w),
        t1: q('[data-rg-waist-t1]', w), t2: q('[data-rg-waist-t2]', w), limits: q('[data-rg-waist-limits]', w), half: q('[data-rg-waist-half]', w),
        lvl: q('[data-rg-waist-level]', w), dot: q('[data-rg-waist-dot]', w), txt: q('[data-rg-waist-text]', w), res: q('[data-rg-waist-result]', w),
        hint: q('[data-rg-waist-scale-hint]', w), zones: qa('[data-rg-waist-track] .rg-waist__zone', w) };
      var lim = { f: [num(w.getAttribute('data-f1'), 80), num(w.getAttribute('data-f2'), 88)], m: [num(w.getAttribute('data-m1'), 94), num(w.getAttribute('data-m2'), 102)] };
      var axis = { f: [64, 106], m: [78, 116] }, hDef = { f: num(w.getAttribute('data-height-f'), 168), m: num(w.getAttribute('data-height-m'), 180) };
      var zone = {}, lv = {}, t = {}; ['ok', 'raised', 'high'].forEach(function (k) { zone[k] = w.getAttribute('data-zone-' + k) || ''; lv[k] = w.getAttribute('data-lvl-' + k) || ''; t[k] = w.getAttribute('data-text-' + k) || ''; });
      var hintLbl = { f: '', m: '' };
      var touched = false;
      function num(s, d) { var v = parseFloat(String(s == null ? '' : s).replace(',', '.')); return isFinite(v) ? v : d; }
      function de(v, d) { return v.toFixed(d).replace('.', ','); }
      function sel(list) { return list.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || list[0]; }
      function fill(s, m) { return String(s).replace(/\{(\w+)\}/g, function (_, k) { return m[k] != null ? m[k] : ''; }); }
      function rank(l) { return l === 'high' ? 2 : l === 'raised' ? 1 : 0; }
      function calc() {
        var sb = sel(sexB); if (!sb) return;
        var sex = sb.getAttribute('data-sex') === 'm' ? 'm' : 'f', l1 = lim[sex][0], l2 = lim[sex][1], a0 = axis[sex][0], a1 = axis[sex][1];
        var wa = num(inW && inW.value, 0), h = num(inH && inH.value, 0);
        if (!(wa >= 40 && wa <= 200 && h >= 120 && h <= 230)) return;
        var lw = wa >= l2 ? 'high' : wa >= l1 ? 'raised' : 'ok';
        var ri = Math.round(wa / h * 100), lr = ri >= 60 ? 'high' : ri >= 50 ? 'raised' : 'ok';
        var level = rank(lr) > rank(lw) ? lr : lw;
        var m = { waist: de(wa, wa % 1 ? 1 : 0), height: String(Math.round(h)), half: de(h / 2, (h / 2) % 1 ? 1 : 0), ratio: de(ri / 100, 2), l1: String(Math.round(l1)), l2: String(Math.round(l2)) };
        var span = a1 - a0, pin = Math.min(100, Math.max(0, (wa - a0) / span * 100)), rpin = Math.min(100, Math.max(0, (ri - 35) / 40 * 100));
        if (out.zones.length === 3) {
          out.zones[0].style.width = ((l1 - a0) / span * 100) + '%'; out.zones[1].style.width = ((l2 - l1) / span * 100) + '%'; out.zones[2].style.width = ((a1 - l2) / span * 100) + '%';
        }
        if (out.val) out.val.textContent = m.waist + ' cm';
        if (out.ratio) out.ratio.textContent = m.ratio;
        if (out.zw) out.zw.textContent = zone[lw];
        if (out.zr) out.zr.textContent = zone[lr];
        if (out.pin) out.pin.style.left = pin + '%';
        if (out.pinval) out.pinval.textContent = m.waist;
        if (out.rpin) out.rpin.style.left = rpin + '%';
        if (out.rpinval) out.rpinval.textContent = m.ratio;
        if (out.t1) out.t1.textContent = m.l1 + ' cm';
        if (out.t2) out.t2.textContent = m.l2 + ' cm';
        if (out.hint) out.hint.textContent = '(' + sb.textContent.trim() + ')';
        if (out.limits) out.limits.innerHTML = 'ab ' + m.l1 + ' cm erhöht<br>ab ' + m.l2 + ' cm deutlich';
        if (out.half) out.half.textContent = 'unter ' + m.half + ' cm';
        if (out.lvl) out.lvl.textContent = lv[level];
        if (out.dot) out.dot.setAttribute('data-level', level);
        if (out.txt) out.txt.textContent = fill(t[level], m);
        if (out.res) { out.res.classList.toggle('rg-waist--high', level === 'high'); out.res.classList.toggle('rg-waist--raised', level === 'raised'); }
      }
      sexB.forEach(function (b) { b.addEventListener('click', function () {
        sexB.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        if (!touched && inH) inH.value = hDef[b.getAttribute('data-sex') === 'm' ? 'm' : 'f'];
        calc();
      }); });
      if (inH) { inH.addEventListener('input', function () { touched = true; calc(); }); inH.addEventListener('change', calc); }
      if (inW) { inW.addEventListener('input', calc); inW.addEventListener('change', calc); }
      calc();
    });
  }

  /* Newsletter: Shopify-Kundenformular per fetch, ohne Seitenwechsel */
  function newsletter() {
    qa('form[data-rg-news]').forEach(function (f) {
      if (f.dataset.rgInit) return; f.dataset.rgInit = '1';
      f.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var btn = q('button', f), ok = q('[data-rg-news-ok]', f.parentNode);
        if (btn) btn.disabled = true;
        fetch(f.action, { method: 'POST', body: new FormData(f), headers: { 'Accept': 'text/html' } })
          .then(function () { if (ok) ok.hidden = false; f.hidden = true; })
          .catch(function () { if (btn) btn.disabled = false; });
      });
    });
  }


  /* Ratgeber-Übersicht: „Mehr laden“ holt die nächste Blog-Seite per Fetch und hängt die Karten an (Fallback = Link) */
  function ixLoadMore() {
    var btn = q('[data-rg-more]'); if (!btn || btn.dataset.rgBound) return;
    btn.dataset.rgBound = '1';
    btn.addEventListener('click', function (ev) {
      var url = btn.getAttribute('data-rg-next'); if (!url || !window.fetch) return;
      ev.preventDefault(); btn.setAttribute('disabled', '');
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        var grid = q('[data-rg-grid]'); var cards = qa('[data-rg-grid] .rg-ix-card', d);
        cards.forEach(function (c) { c.classList.add('rg-in'); grid.appendChild(c); });
        var nb = q('[data-rg-more]', d);
        if (nb && nb.getAttribute('data-rg-next')) {
          btn.setAttribute('data-rg-next', nb.getAttribute('data-rg-next')); btn.setAttribute('href', nb.getAttribute('data-rg-next'));
          var sp = q('span', btn), nsp = q('span', nb); if (sp && nsp) sp.textContent = nsp.textContent;
          btn.removeAttribute('disabled');
        } else { btn.hidden = true; }
      }).catch(function () { btn.removeAttribute('disabled'); window.location.href = url; });
    });
  }

  /* Protein-Rechner (Wie viel Protein am Tag, 14.10.2026): Gewicht (Chips oder Eingabe) x Lebenslage (g je kg als Spanne + Zuschlag g/Tag)
     -> g pro Tag, Anteil je Mahlzeit bei 3 und 4 Mahlzeiten, Hinweis und Quelle der Lebenslage. Kein Produkt im Ergebnis. */
  function protein() {
    qa('[data-rg-protein]').forEach(function (w) {
      if (w.dataset.rgInit) return; w.dataset.rgInit = '1';
      var ws = qa('[data-rg-protein-weights] button', w), gs = qa('[data-rg-protein-groups] button', w), kgIn = q('[data-rg-protein-kg]', w);
      var out = q('[data-rg-protein-out]', w), fac = q('[data-rg-protein-factor]', w), m3 = q('[data-rg-protein-m3]', w), m4 = q('[data-rg-protein-m4]', w);
      var txt = q('[data-rg-protein-text]', w), src = q('[data-rg-protein-src]', w);
      function num(s) { return parseFloat(String(s || '').replace(',', '.')) || 0; }
      function sel(list) { return list.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || list[0]; }
      function de(v) { return String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
      function de1(v) { return String(v).replace('.', ','); }
      function range(lo, hi) { lo = Math.round(lo); hi = Math.round(hi); return lo === hi ? de(lo) : de(lo) + ' bis ' + de(hi); }
      function calc() {
        var g = sel(gs); if (!g) return;
        /* genaues Gewicht aus dem Eingabefeld (30 bis 250 kg) schlaegt die Chips */
        var typed = kgIn ? num(kgIn.value) : 0, exact = typed >= 30 && typed <= 250;
        var wsel = sel(ws), kg = exact ? typed : (wsel ? num(wsel.getAttribute('data-kg')) : 70);
        var lo = num(g.getAttribute('data-min')), hi = num(g.getAttribute('data-max')) || lo, plus = num(g.getAttribute('data-plus'));
        if (hi < lo) hi = lo;
        var tlo = kg * lo + plus, thi = kg * hi + plus;
        if (out) { out.textContent = range(tlo, thi); out.setAttribute('data-long', out.textContent.length > 6 ? '1' : '0'); }
        if (fac) fac.textContent = (lo === hi ? de1(lo) : de1(lo) + ' bis ' + de1(hi)) + ' g je kg' + (plus ? ' + ' + de(plus) + ' g' : '');
        if (m3) m3.textContent = range(tlo / 3, thi / 3) + ' g je Mahlzeit';
        if (m4) m4.textContent = range(tlo / 4, thi / 4) + ' g je Mahlzeit';
        if (txt) txt.innerHTML = '<b>' + g.textContent.trim() + ':</b> ' + (g.getAttribute('data-text') || '');
        if (src) src.textContent = g.getAttribute('data-src') || '';
      }
      var lastChip = sel(ws);
      ws.forEach(function (b) {
        b.addEventListener('click', function () {
          lastChip = b;
          ws.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          if (kgIn) kgIn.value = '';
          calc();
        });
      });
      gs.forEach(function (b) {
        b.addEventListener('click', function () {
          gs.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          calc();
        });
      });
      if (kgIn) kgIn.addEventListener('input', function () {
        var v = num(kgIn.value), ok = v >= 30 && v <= 250;
        /* gueltige Eingabe loest die Chips, leeres oder ungueltiges Feld faellt auf den zuletzt gewaehlten Chip zurueck */
        ws.forEach(function (x) { x.setAttribute('aria-pressed', !ok && x === lastChip ? 'true' : 'false'); });
        calc();
      });
      calc();
    });
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
  doc.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
})();
